webpackJsonp([1],{

/***/ "3jmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fhu+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d32c014e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("ij1X")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-d32c014e"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f26531","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("Fhu+")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f4e819","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("SsTx")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98be2c7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("ZuIu")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e44af22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("cSdr")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutubeOrOlympics: function isYoutubeOrOlympics() {
      return this.videoURL.search('youtube') !== -1 || this.videoURL.search('olympic') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c81c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutubeOrOlympics)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("3jmS")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35db5a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("dUvF")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Get Ready Pack: Dakar 2026",
  "shortTitle": "",
  "description": "",
  "width": 620,
  "height": 877,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://getreadypack.olympics.com/dakar2026/en/"
  }, {
    code: "ES",
    text: "Spanish",
    href: "https://getreadypack.olympics.com/dakar2026/es/"
  }, {
    code: "FR",
    text: "French",
    href: "https://getreadypack.olympics.com/dakar2026/fr/"
  }, {
    code: "ZH",
    text: "Chinese",
    href: "https://getreadypack.olympics.com/dakar2026/zh/"
  }, {
    code: "AR",
    text: "Arabic",
    href: "https://getreadypack.olympics.com/dakar2026/ar/"
  }],
  "basePath": "/dakar2026/en",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "https://getreadypack.olympics.com/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/dakar2026/en/static/_content/Athlete365_GetReadyPack_Dakar_2026.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 1-title\" style=\"top:40px;left:463px;\" src=\"/dakar2026/en/static/_content/1-title-1.png\"/>\n      <img class=\"abs halfScale 1-title\" style=\"top:170px;left:345px;\" src=\"/dakar2026/en/static/_content/1-title-2.png\"/>\n      <img class=\"abs halfScale 1-title\" style=\"top:301px;left:394px;\" src=\"/dakar2026/en/static/_content/1-title-3.png\"/>\n      <img class=\"abs halfScale 1-sub\" style=\"top:430px;left:427px;\" src=\"/dakar2026/en/static/_content/1-sub-1.png\"/>\n      <img class=\"abs halfScaleC 1-logo\" style=\"top:749px;left:515px;\" src=\"/dakar2026/en/static/_content/1-logo-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.staggerFromTo(cOf(\"1-title\"), 0.8, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"1-sub\"), 0.7, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"1-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8);\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "get ready PACK  DAKAR 2026"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 2-title\" style=\"top:76px;left:20px;\" src=\"/dakar2026/en/static/_content/2-title-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(3);\" style=\"top:167px; left:72px; width:208px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" style=\"top:180px; left:72px; width:208px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(5);\" style=\"top:193px; left:72px; width:208px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(6);\" style=\"top:207px; left:72px; width:208px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(7);\" style=\"top:221px; left:72px; width:208px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:234px; left:72px; width:208px; height:13px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(10);\" style=\"top:269px; left:72px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(11);\" style=\"top:295px; left:72px; width:198px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(12);\" style=\"top:307px; left:72px; width:198px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(13);\" style=\"top:322px; left:72px; width:198px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" style=\"top:336px; left:72px; width:198px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(15);\" style=\"top:349px; left:72px; width:198px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:363px; left:72px; width:198px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(17);\" style=\"top:376px; left:72px; width:198px; height:13px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(18);\" style=\"top:403px; left:72px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(19);\" style=\"top:430px; left:72px; width:160px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(20);\" style=\"top:444px; left:72px; width:160px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(21);\" style=\"top:458px; left:72px; width:160px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(22);\" style=\"top:472px; left:72px; width:160px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(23);\" style=\"top:486px; left:72px; width:160px; height:13px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(24);\" style=\"top:163px; left:371px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(25);\" style=\"top:189px; left:370px; width:138px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(26);\" style=\"top:203px; left:370px; width:138px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(27);\" style=\"top:217px; left:370px; width:138px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(28);\" style=\"top:230px; left:370px; width:138px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(29);\" style=\"top:245px; left:370px; width:138px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(30);\" style=\"top:258px; left:370px; width:138px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(31);\" style=\"top:273px; left:370px; width:138px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(32);\" style=\"top:285px; left:370px; width:138px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(33);\" style=\"top:300px; left:370px; width:138px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(34);\" style=\"top:313px; left:370px; width:138px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(37);\" style=\"top:328px; left:370px; width:138px; height:13px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(38);\" style=\"top:354px; left:371px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(39);\" style=\"top:380px; left:370px; width:148px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(40);\" style=\"top:394px; left:370px; width:148px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(41);\" style=\"top:407px; left:370px; width:148px; height:13px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(42);\" style=\"top:421px; left:370px; width:148px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(43);\" style=\"top:435px; left:370px; width:148px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(44);\" style=\"top:448px; left:370px; width:148px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(45);\" style=\"top:462px; left:370px; width:148px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(46);\" style=\"top:476px; left:370px; width:148px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(47);\" style=\"top:491px; left:370px; width:148px; height:13px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(48);\" style=\"top:505px; left:370px; width:148px; height:13px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim.fromTo(cOf(\"2-title\"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Contents  Contents  2  Contents 3 4 5 6 7 8  Start your Olympic journey Athlete365 app Welcome to Dakar 2026 Africa Welcomes, Dakar Celebrates Get to know Senegal Games map  Your YOG essentials 11 Arrivals 12 Accreditation 13 Getting to your competition venue 14 Cluster overview: Dakar 15 Cluster overview: Diamniadio 16 Cluster overview: Saly 17 Ceremonies  Life in the Village 19 Youth Olympic Village map 20 Accommodation 21 Village services 22 Athlete365 House 23 Eating and drinking  Athlete Education Programme 25 Introduction 26 Overview 27 Learning courses 28 PinQuest 29 Integrity 30 Career support 31 Health and well-being 32 Digital and media 33 Olympic Impact 34 Athlete Role Models 37 Inside Sport Sessions  Need to know 39 How to seek help 40 Online abuse protection 41 Mindfulness app 42 Anti-doping 43 Athlete expression 44 Content guidelines 45 How to access tickets 46 Get Set – Train Smarter 47 Sustainability 48 Departures"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 3-title\" style=\"top:76px;left:21px;\" src=\"/dakar2026/en/static/_content/3-title-1.png\"/>\n      <img class=\"abs halfScale 3-title\" style=\"top:138px;left:21px;\" src=\"/dakar2026/en/static/_content/3-title-2.png\"/>\n      <img class=\"abs halfScale 3-title\" style=\"top:197px;left:21px;\" src=\"/dakar2026/en/static/_content/3-title-3.png\"/>\n      <img class=\"abs halfScale 3-title\" style=\"top:274px;left:21px;\" src=\"/dakar2026/en/static/_content/3-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 3-icon\" style=\"top:426px;left:-25px;\" src=\"/dakar2026/en/static/_content/3-icon-1.png\"/>\n      <img class=\"abs halfScaleC 3-icon\" style=\"top:507px;left:-25px;\" src=\"/dakar2026/en/static/_content/3-icon-2.png\"/>\n      <img class=\"abs halfScaleC 3-icon\" style=\"top:587px;left:-25px;\" src=\"/dakar2026/en/static/_content/3-icon-3.png\"/>\n      <img class=\"abs halfScaleC 3-icon\" style=\"top:667px;left:-25px;\" src=\"/dakar2026/en/static/_content/3-icon-4.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/auth/sign-in\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 3-button pointer\" style=\"top:765px;left:22px;\" src=\"/dakar2026/en/static/_content/3-button-1.png\"/>\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.staggerFromTo(cOf(\"3-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"3-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.7);\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Start your Olympic journey  Contents  Start your Olympic journey with Athlete365 Our mission is to make athletes’ lives better. Athlete365 is the global community for athletes and their entourage members. With more than 210,000 members from around the world, we support you with:  Exclusive offers  Practical resources  Learning opportunities  Games-time information  Sign up now  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 4-title\" style=\"top:411px;left:20px;\" src=\"/dakar2026/en/static/_content/4-title-1.png\"/>\n      <img class=\"abs halfScale 4-title\" style=\"top:472px;left:20px;\" src=\"/dakar2026/en/static/_content/4-title-2.png\"/>\n      <img class=\"abs halfScale 4-title\" style=\"top:544px;left:20px;\" src=\"/dakar2026/en/static/_content/4-sub-1.png\"/>\n\n      <a href=\"http://athlete365.org/download\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 4-button pointer\" style=\"top:723px;left:160px;\" src=\"/dakar2026/en/static/_content/4-button-1.png\"/>\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete365 app  Download the Athlete365 app Everything that Athlete365 has to offer, right at your fingertips. Your go-to destination for our practical resources, learning opportunities and exclusive offers, the Athlete365 app is split into five sections:  Learning  Home  Your network  The latest news from Athlete365.  For you  Log in to access a personalised feed and track your Athlete365 Learning progress.  Games  Everything you need to know before, during and after your time at Dakar 2026.  Easy access to all of our bespoke educational courses, with insight from experts and Worldwide Olympic Partners.  Keep up to date with the global athlete community and meet your representatives from the IOC Athletes’ Commission.  Download the Athlete365 app now  4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 5-title\" style=\"top:302px;left:20px;\" src=\"/dakar2026/en/static/_content/5-title-1.png\"/>\n      <img class=\"abs halfScale 5-title\" style=\"top:354px;left:23px;\" src=\"/dakar2026/en/static/_content/5-title-2.png\"/>\n      <img class=\"abs halfScale 5-title\" style=\"top:417px;left:20px;\" src=\"/dakar2026/en/static/_content/5-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 5-icon\" style=\"top:106px;left:140px;\" src=\"/dakar2026/en/static/_content/5-icon-1.png\"/>\n\n      <img class=\"abs halfScaleC 5-icon\" style=\"top:484px;left:-17px;\" src=\"/dakar2026/en/static/_content/5-icon-2.png\"/>\n      <h1 id=\"5-no\" class=\"abs olympicHeadlineReg 5-no\" style=\"top:514px;left:104px; font-size: 5.1em; font-weight: 300; color: #01287f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2700, \"comma\": true}' ></h1>\n      <img class=\"abs halfScale 5-text\" style=\"top:547px;left:261px;\" src=\"/dakar2026/en/static/_content/5-text-1.png\"/>\n\n      <img class=\"abs halfScaleC 5-icon\" style=\"top:592px;left:2px;\" src=\"/dakar2026/en/static/_content/5-icon-3.png\"/>\n      <h1 id=\"5-no\" class=\"abs olympicHeadlineReg 5-no\" style=\"top:630px;left:103px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 25}' ></h1>\n      <img class=\"abs halfScale 5-text\" style=\"top:643px;left:139px;\" src=\"/dakar2026/en/static/_content/5-text-2.png\"/>\n\n      <img class=\"abs halfScaleC 5-icon\" style=\"top:592px;left:286px;\" src=\"/dakar2026/en/static/_content/5-icon-4.png\"/>\n      <h1 id=\"5-no\" class=\"abs olympicHeadlineReg 5-no\" style=\"top:630px;left:388px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10}' ></h1>\n      <img class=\"abs halfScale 5-text\" style=\"top:643px;left:419px;\" src=\"/dakar2026/en/static/_content/5-text-3.png\"/>\n\n      <h1 id=\"5-no\" class=\"abs olympicHeadlineReg 5-no\" style=\"top:696px;left:274px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50, \"append\" : \"/\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs olympicHeadlineReg 5-no\" style=\"top:696px;left:316px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50}' ></h1>\n      <img class=\"abs halfScale 5-bottom-text\" style=\"top:734px;left:255px;\" src=\"/dakar2026/en/static/_content/5-text-5.png\"/>\n      <img class=\"abs halfScale 5-line\" style=\"top:714px;left:163px;\" src=\"/dakar2026/en/static/_content/5-line-1.png\"/>\n      <img class=\"abs halfScale 5-line\" style=\"top:714px;left:352px;\" src=\"/dakar2026/en/static/_content/5-line-2.png\"/>\n      <img class=\"abs halfScale 5-bottom-icon\" style=\"top:761px;left:20px;\" src=\"/dakar2026/en/static/_content/5-icon-5.png\"/>\n      <img class=\"abs halfScale 5-bottom-icon\" style=\"top:761px;left:311px;\" src=\"/dakar2026/en/static/_content/5-icon-6.png\"/>\n      <img class=\"abs halfScale 5-bottom-icon\" style=\"top:755px;left:309px;\" src=\"/dakar2026/en/static/_content/5-line-3.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim.staggerFromTo(cOf(\"5-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"5-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.5)\n\n          .fromTo(cOf(\"5-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[0])}}, 1.9)\n          .staggerFromTo(cOf(\"5-text\"), 0.6, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 2)\n          .fromTo(cOf(\"5-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[1])}}, 2.1)\n          .fromTo(cOf(\"5-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[2])}}, 2.3)\n\n          .fromTo(cOf(\"5-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[3])}}, 2.8)\n          .fromTo(cOf(\"5-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[4])}}, 2.8)\n          .fromTo(cOf(\"5-bottom-text\"), 0.5, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3)\n          .fromTo(cOf(\"5-line\"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.2)\n          .fromTo(cOf(\"5-bottom-icon\"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.2);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          resetNumbers(\"5-no\");\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Welcome to Dakar 2026  Contents  5  Welcome to Dakar 2026 Dakar 2026 is the 4th Summer Youth Olympic Games (YOG) – and the first Olympic sporting event to be held in Africa.  2,700 25  athletes  10  competition sports  50/50  full gender equality  engagement sports"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 6-title\" style=\"top:85px;left:20px;\" src=\"/dakar2026/en/static/_content/6-title-1.png\"/>\n      <img class=\"abs halfScale 6-title\" style=\"top:136px;left:20px;\" src=\"/dakar2026/en/static/_content/6-title-2.png\"/>\n      <img class=\"abs halfScale 6-title\" style=\"top:200px;left:20px;\" src=\"/dakar2026/en/static/_content/6-sub-1.png\"/>\n\n      <img class=\"abs halfScale 6-title\" style=\"top:298px;left:20px;\" src=\"/dakar2026/en/static/_content/6-text-1.png\"/>\n      <img class=\"abs halfScale 6-caption\" style=\"top:338px;left:195px;\" src=\"/dakar2026/en/static/_content/6-caption-1.png\"/>\n      <img class=\"abs halfScale 6-text\" style=\"top:369px;left:181px;\" src=\"/dakar2026/en/static/_content/6-text-2.png\"/>\n      <img class=\"abs halfScale 6-caption\" style=\"top:338px;left:351px;\" src=\"/dakar2026/en/static/_content/6-caption-2.png\"/>\n      <img class=\"abs halfScale 6-text\" style=\"top:369px;left:327px;\" src=\"/dakar2026/en/static/_content/6-text-3.png\"/>\n      <img class=\"abs halfScale 6-caption\" style=\"top:338px;left:508px;\" src=\"/dakar2026/en/static/_content/6-caption-3.png\"/>\n      <img class=\"abs halfScale 6-text\" style=\"top:369px;left:476px;\" src=\"/dakar2026/en/static/_content/6-text-4.png\"/>\n\n      <img class=\"abs halfScaleC 6-icon\" style=\"top:222px;left:167px;\" src=\"/dakar2026/en/static/_content/6-icon-1.png\"/>\n      <img class=\"abs halfScaleC 6-icon\" style=\"top:222px;left:317px;\" src=\"/dakar2026/en/static/_content/6-icon-2.png\"/>\n      <img class=\"abs halfScaleC 6-icon\" style=\"top:222px;left:468px;\" src=\"/dakar2026/en/static/_content/6-icon-3.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.staggerFromTo(cOf(\"6-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"6-caption\"), 0.7, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.7)\n          .fromTo(cOf(\"6-text\"), 0.7, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)\n          .fromTo(cOf(\"6-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Africa Welcomes, Dakar Celebrates  6  Africa Welcomes, Dakar Celebrates Dakar 2026 will unite youth and sport, drive the transformation of Senegal, and provide inspiration for all of Africa.  As an athlete at Dakar 2026, you are part of history as you compete in the first Olympic sporting event to be held on African soil – but this Youth Olympic Games is so much more than that.  By the youth, for the youth  Dakar 2026 will give you a platform to shine and provide opportunities for young people in Senegal and across Africa.  A celebration of Africa  Dakar 2026 will highlight the cultural wealth of Senegal and showcase the diversity and potential of Africa to the world.  A catalyst for change  Dakar 2026 will bring lasting economic, social and environmental benefits to the local population."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 7-title\" style=\"top:99px;left:20px;\" src=\"/dakar2026/en/static/_content/7-title-1.png\"/>\n      <img class=\"abs halfScale 7-title\" style=\"top:161px;left:20px;\" src=\"/dakar2026/en/static/_content/7-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/app/uploads/2026/NCS-250930-Welcome-to-Dakar-EN.pdf\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 7-button pointer\" style=\"top:775px;left:402px;\" src=\"/dakar2026/en/static/_content/7-button-1.png\"/>\n      </a>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.staggerFromTo(cOf(\"7-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Get to know Senegal  7  Get to know Senegal From the spirit of ‘Teranga’ to some favourite local dishes, here’s what you can expect from your host country. ‘Teranga’  Senegal is known as the land of Teranga – a word in the local Wolof language that embodies the country’s unique spirit of warmth, respect and hospitality. Teranga is deeply embedded in Senegalese life, reflecting the country’s culture of generosity and openness towards others.  TIP: Always greet people when you arrive somewhere – greetings are very important in Senegalese culture.  Senegalese food  Senegalese cuisine is characterised by flavourful dishes prepared in large portions to be shared with family and friends. It blends local traditions with North African, French and Asian influences. Iconic dishes: • Thiebou djeun – The national dish of Senegal – a one-pot meal made with rice, fish and vegetables in a rich tomato sauce. • Mafé – An iconic West African stew with tender meat and vegetables in a rich peanut sauce. • Yassa – Bone-in chicken marinated in a tangy and spicy lemon sauce. • C’est bon – Grilled fish in a tomato and onion sauce.  FIND OUT MORE about Senegal with our Welcome to Dakar guide.  read the guide"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n\n      <img class=\"abs halfScale 8-title\" style=\"top:68px;left:20px;\" src=\"/dakar2026/en/static/_content/8-title-1.png\"/>\n      <img class=\"abs halfScale 8-title\" style=\"top:130px;left:20px;\" src=\"/dakar2026/en/static/_content/8-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 8-icon\" id=\"pg8Arrow\" style=\"top:112px;left:281px;\" src=\"/dakar2026/en/static/_content/8-icon-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" style=\"top:344px;left:154px;width:63px;height:27px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(15);\" style=\"top:213px;left:492px;width:83px;height:27px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.staggerFromTo(cOf(\"8-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"8-icon\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.6);\n          setTimeout(function(){\n            addContentLinks();\n            addPulse(\"pg8Arrow\")\n          }, 3000)\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          removeContentLinks();\n          removePulse(\"pg8Arrow\")\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Games map  Contents  8  Games map Click on your cluster to find out more.  DiAMNiADiO 2km  AD  7 G  4  7  4 5  5  6 6  Diamniadio TER Station  E A1  DAKAR  C  7 mins  A1 H  H  F  B 20km  1 1 35km  3  4. EQUESTRIAN CENTRE 17 mins  Dakar TER Station  2 2  Equestrian (Jumping)  60 mins  5. DAKAR ARENA  A  7. DAKAR EXPO CENTRE  10 mins  1. COMPLEXE TOUR DE L'OEUF 90 mins  Swimming 106 3×3mins Basketball  Breaking 1. COMPLEXE TOUR DE L'OEUF  Baseball5 Swimming Skateboarding (Street) 3×3 Basketball  Breaking Baseball5 IBA MAR DIOP 2. COMPLEXE Skateboarding (Street) 75 mins Rugby Sevens Athletics Taekwondo Futsal 87 mins  MAIN HOSPiTAL OF DAKAR 2. A. COMPLEXE IBA MAR DIOP 125 mins  10 mins  Badminton  Fencing  Futsal  3. CORNiCHE WEST  Boxing Table Tennis  110 mins  6. ABDOULAYE WADE STADIUM  Cycling Road  Wushu (Taolu) Artistic Gymnastics 5 mins  5 mins  Engagement sports  Judo  Archery  Weightlifting Tennis  Archery Intl’ Broadcast Centre Cycling Road  Opening Ceremony  Karate Shooting  YOV  Surfing  E. MAiN LOGiSTiCS HUB  26 mins  Athletics (track)  14 mins  Futsal  7 mins  4. CENTRE EQUESTRE 3×3 Basketball F. UNiFORM AND Equestrian (Jumping) Baseball5 ACCREDiTATiON CENTRE  Sport Climbing Hockey Golf Modern Pentathlon  Rugby Sevens  Canoe  ENGAGEMENT SPORTS*  *Locations to be confirmed  Taekwondo  G. CICAD  Triathlon (running)  Main Press Centre  10 mins  Weightlifting  Sport Climbing  Closing Ceremony  Rugby Sevens  Tennis  Hockey  19 mins D. THE GROUND 14 mins 5. DAKAR ARENA  B. MiLiTARY HOSPiTAL OF OUAKAM Athletics 125 mins  Karate  Golf  Boxing  Shooting  Modern Pentathlon  125 mins Futsal  Surfing  Canoe  C. DAKAR 2026 HEADQUARTERS Main Operations Centre Technology Operations Centre  6. STADE ABDOULAYE WADE  Swimming Boxing  H. YOG HOSPITAL 19 mins  Gymnastics  Badminton Artistic Gymnastics Triathlon (swimming)  19 mins  7. DAKAR EXPO CENTRE Fencing Taekwondo Table Tennis Wushu (Taolu) Artistic Gymnastics Judo"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:700px;left:249px;width:46px;height:26px;border-radius:0px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n        setTimeout(function(){\n            addContentLinks();\n          },3000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "High  Get Ready Pack: Dakar 2026 | Games map  Contents  9  DAKAR 2026 MASTER PLAN X X X  Competition Venues  X X X  NON-Comp Venues Competition  way  A1 Airport TER Station  Training Engagement Sports  Blaise Diagne International Airport  Youth Olympic Village  35 mins  H A1  35 mins  igh  Blaise Diagne International Airport  y wa  A1 Highway Train Express Régional (TER) TER Stations Shuttle  20km  Travel time from YOV  35km  A1  ATLANTIC OCEAN  56 mins  8. SALY BEACH WEST 8. SALY PLAGE OUEST 55 mins  8 8  SALY  Sailing (Windsurfing)  Rowing Coastal Beach Sailing (Windsurfing) Sprints Rowing Coastal  Beach Volleyball Beach Sprints Beach Volleyball Beach Handball  Beach Handball Beach Wrestling Beach Wrestling Triathlon Triathlon  50km"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 10-title\" style=\"top:206px;left:217px;\" src=\"/dakar2026/en/static/_content/10-title-1.png\"/>\n      <img class=\"abs halfScale 10-title\" style=\"top:288px;left:220px;\" src=\"/dakar2026/en/static/_content/10-title-2.png\"/>\n      <img class=\"abs halfScale 10-title\" style=\"top:380px;left:220px;\" src=\"/dakar2026/en/static/_content/10-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(11);\" style=\"top:480px; left:216px; width:296px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(12);\" style=\"top:513px; left:216px; width:296px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(13);\" style=\"top:546px; left:216px; width:296px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" style=\"top:580px; left:216px; width:296px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(15);\" style=\"top:614px; left:216px; width:296px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:648px; left:216px; width:296px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(17);\" style=\"top:680px; left:216px; width:296px; height:22px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim.staggerFromTo(cOf(\"10-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Your YOG essentials  YOUR YOG ESSENTIALS Navigate the Games with confidence.  11  Arrivals  12  Accreditation  13  Getting to your competition venue  14  Cluster overview: Dakar  15  Cluster overview: Diamniadio  16  Cluster overview: Saly  17  Ceremonies  10"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 11-title\" style=\"top:501px;left:21px;\" src=\"/dakar2026/en/static/_content/11-title-1.png\"/>\n      <img class=\"abs halfScale 11-title\" style=\"top:565px;left:21px;\" src=\"/dakar2026/en/static/_content/11-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim.staggerFromTo(cOf(\"11-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Arrivals  11  Arrivals What to expect when you arrive in Senegal.  1  When you arrive at the airport, your NOC will accompany you through immigration and baggage claim.  2 You will then go to the transport zone, where you will board a bus to the Youth Olympic Village. arrival at the Youth Olympic Village, you will go through a security check and your baggage will 3 On be taken to a storage area.  4 You will then pick up your accreditation – more information on the next page. 5 When you have your accreditation, staff will direct you to your accommodation. your yog essentials"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 12-title\" style=\"top:100px;left:21px;\" src=\"/dakar2026/en/static/_content/12-title-1.png\"/>\n      <img class=\"abs halfScale 12-title\" style=\"top:163px;left:21px;\" src=\"/dakar2026/en/static/_content/12-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 12-icon\" style=\"top:179px;left:16px;\" src=\"/dakar2026/en/static/_content/12-icon-1.png\"/>\n      <img class=\"abs halfScale 12-caption\" style=\"top:343px;left:38px;\" src=\"/dakar2026/en/static/_content/12-caption-1.png\"/>\n      <img class=\"abs halfScale 12-line\" style=\"top:220px;left:210px;\" src=\"/dakar2026/en/static/_content/12-line.png\"/>\n\n      <img class=\"abs halfScaleC 12-icon\" style=\"top:179px;left:216px;\" src=\"/dakar2026/en/static/_content/12-icon-2.png\"/>\n      <img class=\"abs halfScale 12-caption\" style=\"top:343px;left:236px;\" src=\"/dakar2026/en/static/_content/12-caption-2.png\"/>\n      <img class=\"abs halfScale 12-line\" style=\"top:220px;left:410px;\" src=\"/dakar2026/en/static/_content/12-line.png\"/>\n\n      <img class=\"abs halfScaleC 12-icon\" style=\"top:179px;left:416px;\" src=\"/dakar2026/en/static/_content/12-icon-3.png\"/>\n      <img class=\"abs halfScale 12-caption\" style=\"top:343px;left:435px;\" src=\"/dakar2026/en/static/_content/12-caption-3.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.staggerFromTo(cOf(\"12-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n\n          .staggerFromTo(cOf(\"12-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)\n          .staggerFromTo(cOf(\"12-caption\"), 0.8, {opacity:0, y: 25}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.5)\n          .staggerFromTo(cOf(\"12-line\"), 0.8, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.6);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Accreditation  Contents  12  Accreditation Everything you need to know about your accreditation and how to keep it safe. For more information, please contact your NOC.  1  2  3  When you arrive at the Youth Olympic Village, you will be taken to pick up your Youth Olympic Accreditation Card (YOAC).  At the Accreditation Centre, present your passport and visa (if applicable) to collect your YOAC.  Your YOAC is your official accreditation, granting you access to the venues and services you need. You must carry it with you at all times, apart from training or competition.  TIP: Hang your accreditation on the inside door handle of your room before you go to bed. Then, when you leave your room, you’ll be reminded to put it on.  your yog essentials"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 13-title\" style=\"top:100px;left:21px;\" src=\"/dakar2026/en/static/_content/13-title-1.png\"/>\n      <img class=\"abs halfScale 13-title\" style=\"top:150px;left:21px;\" src=\"/dakar2026/en/static/_content/13-title-2.png\"/>\n      <img class=\"abs halfScale 13-title\" style=\"top:214px;left:21px;\" src=\"/dakar2026/en/static/_content/13-sub-1.png\"/>\n   \n      <img class=\"abs halfScale 13-dakar\" style=\"top:209px;left:341px;\" src=\"/dakar2026/en/static/_content/13-dakar.png\"/>\n      <img class=\"abs halfScaleC 13-icon\" style=\"top:236px;left:248px;\" src=\"/dakar2026/en/static/_content/13-dakar-icon-group-1.png\"/>\n      <img class=\"abs halfScaleC 13-icon\" style=\"top:315px;left:248px;\" src=\"/dakar2026/en/static/_content/13-dakar-icon-group-2.png\"/>\n      <img class=\"abs halfScaleC 13-icon\" style=\"top:409px;left:248px;\" src=\"/dakar2026/en/static/_content/13-dakar-icon-group-3.png\"/>\n      <img class=\"abs halfScale 13-dakar-text\" style=\"top:282px;left:402px;\" src=\"/dakar2026/en/static/_content/13-dakar-text-1.png\"/>\n      <img class=\"abs halfScale 13-dakar-text\" style=\"top:356px;left:402px;\" src=\"/dakar2026/en/static/_content/13-dakar-text-2.png\"/>\n      <img class=\"abs halfScale 13-dakar-text\" style=\"top:454px;left:402px;\" src=\"/dakar2026/en/static/_content/13-dakar-text-3.png\"/>\n\n      <img class=\"abs halfScale 13-saly\" style=\"top:571px;left:411px;\" src=\"/dakar2026/en/static/_content/13-saly.png\"/>\n      <img class=\"abs halfScaleC 13-icon\" style=\"top:540px;left:450px;\" src=\"/dakar2026/en/static/_content/13-saly-icon-group-1.png\"/>\n      <img class=\"abs halfScaleC 13-saly-text\" style=\"top:662px;left:415px;\" src=\"/dakar2026/en/static/_content/13-saly-text-1.png\"/>\n\n      <img class=\"abs halfScale 13-diamniadio\" style=\"top:447px;left:120px;\" src=\"/dakar2026/en/static/_content/13-diamniadio.png\"/>\n\n      <img class=\"abs halfScaleC 13-diamniadio-text\" style=\"top:503px;left:147px;\" src=\"/dakar2026/en/static/_content/13-diamniadio-text-1.png\"/>\n      <img class=\"abs halfScaleC 13-diamniadio-text\" style=\"top:556px;left:175px;\" src=\"/dakar2026/en/static/_content/13-diamniadio-text-2.png\"/>\n      <img class=\"abs halfScaleC 13-diamniadio-text\" style=\"top:658px;left:169px;\" src=\"/dakar2026/en/static/_content/13-diamniadio-text-3.png\"/>\n      <img class=\"abs halfScaleC 13-diamniadio-text\" style=\"top:741px;left:146px;\" src=\"/dakar2026/en/static/_content/13-diamniadio-text-4.png\"/>\n      <img class=\"abs halfScaleC 13-icon\" style=\"top:500px;left:212px;\" src=\"/dakar2026/en/static/_content/13-diamniadio-icon-group-1.png\"/> \n      <img class=\"abs halfScaleC 13-icon\" style=\"top:554px;left:212px;\" src=\"/dakar2026/en/static/_content/13-diamniadio-icon-group-2.png\"/>\n      <img class=\"abs halfScaleC 13-icon\" style=\"top:656px;left:212px;\" src=\"/dakar2026/en/static/_content/13-diamniadio-icon-group-3.png\"/>\n      <img class=\"abs halfScaleC 13-icon\" style=\"top:744px;left:212px;\" src=\"/dakar2026/en/static/_content/13-diamniadio-icon-group-4.png\"/>\n\n      <img class=\"abs halfScaleC 13-icon-big\" style=\"top:555px;left:283px;\" src=\"/dakar2026/en/static/_content/13-icon-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.staggerFromTo(cOf(\"13-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"13-icon-big\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.7)\n          .fromTo(cOf(\"13-dakar\"), 0.8, {opacity:0, y: -15}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"13-saly\"), 0.8, {opacity:0, x: 15}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"13-diamniadio\"), 0.8, {opacity:0, x: -15}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2)\n          .staggerFromTo(cOf(\"13-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 2.2)\n          .staggerFromTo(cOf(\"13-dakar-text\"), 0.8, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2.4)\n          .staggerFromTo(cOf(\"13-saly-text\"), 0.8, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2.4)\n          .staggerFromTo(cOf(\"13-diamniadio-text\"), 0.8, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2.4);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Getting to your competition venue  Contents  13  Getting to your competition venue Average travel time between the Village and each competition venue. The transport system at Dakar 2026 is made up of trains and buses. When travelling between the Youth Olympic Village and your competition or training venues, you should be accompanied at all times by someone from your NOC.  Equestrian (EQU)  Badminton (BDM) Futsal (FBS)  110 min  DAR  10 min  Boxing (BOX) Fencing (FEN) Artistic Gymnastics (GAR)  Judo (JUD) Table Tennis (TTE)  DEX  Dakar Expo Centre  10 min  Wushu (WST) Opening Ceremony Archery (ARC)  your yog essentials  SAW  Abdoulaye Wade Stadium  Cycling Road (CRD)  COR  Corniche West  5 min  Basket 3x3 (BK3)  CTO  90 min  17 min  Dakar Arena  Walk  Baseball 5 (BS5)  CED  Equestrian Centre  Train  DAKAR  Breaking (BKG)  Complexe Tour de l'Oeuf  75 min  DIAMNIADIO  Bus  Skateboarding (SKB) Swimming (SWM)  Athletics (ATH)  CID  Rugby 7 (RU7)  Complexe Iba Mar Diop  Taekwondo (TKW) Futsal (FBS)  56 min  YOUTH OLYMPIC VILLAGE  SALY  SBW  Saly Beach West  Beach Handball (HBB)  Triathlon (TRI)  Beach Volleyball (VBV)  Sailing (SAL)  Beach Wrestling (WRB)  Rowing (RCB)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 14-title\" style=\"top:80px;left:21px;\" src=\"/dakar2026/en/static/_content/14-sub-1.png\"/>\n      <img class=\"abs halfScale 14-title\" style=\"top:102px;left:21px;\" src=\"/dakar2026/en/static/_content/14-title-1.png\"/>\n      <img class=\"abs halfScale 14-title\" style=\"top:163px;left:21px;\" src=\"/dakar2026/en/static/_content/14-sub-2.png\"/>\n\n      <img class=\"abs halfScale 14-box\" style=\"top:224px;left:21px;\" src=\"/dakar2026/en/static/_content/14-box-1.png\"/>\n      <img class=\"abs halfScale 14-box\" style=\"top:426px;left:21px;\" src=\"/dakar2026/en/static/_content/14-box-2.png\"/>\n      <img class=\"abs halfScale 14-box\" style=\"top:628px;left:21px;\" src=\"/dakar2026/en/static/_content/14-box-3.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.staggerFromTo(cOf(\"14-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"14-box\"), 0.8, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.7);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Cluster overview: Dakar  Contents  14  Cluster overview:  Dakar Dakar will host major and urban sports in iconic venues located in the heart of the city.  Complexe Tour de l’Oeuf Located in the heart of lively and vibrant neighbourhood Point E, Complexe Tour de l’Oeuf will be a central hub for competitions as well as cultural and festive experiences.  Complexe Iba Mar Diop A historic venue that hosted the 1st African Athletics Championships in 1979, Complexe Iba Mar Diop has been transformed for Dakar 2026.  Corniche West An iconic road along the Dakar seashore that will host the road cycling competition and engagement sports activities.  your yog essentials  Sports 3x3 basketball  Baseball5  Swimming  Skateboarding (street)  Breaking  Services Athlete dining with buffet-style meal service  Athletes’ Lounge with drinks and light refreshments  Sports Rugby sevens  Futsal  (group stage)  Athletics  Taekwondo  Services Athlete dining with buffet-style meal service  Sports Cycling road  Services Athletes’ Lounge with drinks and light refreshments  Athletes’ Lounge with drinks and light refreshments"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 15-title\" style=\"top:78px;left:21px;\" src=\"/dakar2026/en/static/_content/15-sub-1.png\"/>\n      <img class=\"abs halfScale 15-title\" style=\"top:98px;left:21px;\" src=\"/dakar2026/en/static/_content/15-title-1.png\"/>\n      <img class=\"abs halfScale 15-title\" style=\"top:161px;left:21px;\" src=\"/dakar2026/en/static/_content/15-sub-2.png\"/>\n\n      <img class=\"abs halfScale 15-box\" style=\"top:224px;left:21px;\" src=\"/dakar2026/en/static/_content/15-box-1.png\"/>\n      <img class=\"abs halfScale 15-box\" style=\"top:374px;left:21px;\" src=\"/dakar2026/en/static/_content/15-box-2.png\"/>\n      <img class=\"abs halfScale 15-box\" style=\"top:528px;left:21px;\" src=\"/dakar2026/en/static/_content/15-box-3.png\"/>\n      <img class=\"abs halfScale 15-box\" style=\"top:684px;left:21px;\" src=\"/dakar2026/en/static/_content/15-box-4.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.staggerFromTo(cOf(\"15-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"15-box\"), 0.8, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.7);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Cluster overview: Diamniadio  Contents  15  Cluster overview:  Diamniadio Diamniadio is the home of the Youth Olympic Village and the majority of indoor venues.  Dakar Expo Centre A modern exhibition complex with six halls hosting six sports.  Dakar Arena  Sports Artistic gymnastics  Boxing  Fencing  Judo  Table tennis  Wushu  Sports Badminton  An indoor sports venue offering a world-class stage for athletes and spectators.  Equestrian Centre A brand-new venue equipped with top-tier facilities and grandstands for more than 1,200 spectators.  Abdoulaye Wade Stadium Dakar’s landmark sports venue and the home of the Senegal national football team.  your yog essentials  Services  Sports  Athletes’ Lounge with drinks and light refreshments  Services Athletes’ Lounge with drinks and light refreshments  Futsal  (final group games, semi-finals, finals)  Services Athletes’ Lounge with drinks and light refreshments  Equestrian (jumping)  Sports Archery  Services Athletes’ Lounge with drinks and light refreshments"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 16-title\" style=\"top:80px;left:21px;\" src=\"/dakar2026/en/static/_content/16-sub-1.png\"/>\n      <img class=\"abs halfScale 16-title\" style=\"top:100px;left:21px;\" src=\"/dakar2026/en/static/_content/16-title-1.png\"/>\n      <img class=\"abs halfScale 16-title\" style=\"top:161px;left:21px;\" src=\"/dakar2026/en/static/_content/16-sub-2.png\"/>\n\n      <img class=\"abs halfScale 16-box\" style=\"top:224px;left:21px;\" src=\"/dakar2026/en/static/_content/16-box-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.staggerFromTo(cOf(\"16-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"16-box\"), 0.8, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.7);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Cluster overview: Saly  Contents  16  Cluster overview:  Saly  With its unique seaside setting, Saly is dedicated to beach and water sports.  Saly Beach West Saly Beach West is an internationally renowned seaside destination that will be transformed into a dynamic hub for sport, culture and celebration.  your yog essentials  Sports Beach handball  Beach volleyball  Beach wrestling  Rowing Sailing coastal beach (windsurfing) sprints  Triathlon  Services Athlete dining with buffet-style meal service  Athletes’ Lounge with drinks and light refreshments"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 17-title\" style=\"top:100px;left:21px;\" src=\"/dakar2026/en/static/_content/17-title-1.png\"/>\n      <img class=\"abs halfScale 17-title\" style=\"top:161px;left:21px;\" src=\"/dakar2026/en/static/_content/17-sub-1.png\"/>\n\n      <img class=\"abs halfScale 17-box\" style=\"top:239px;left:20px;\" src=\"/dakar2026/en/static/_content/17-box-1.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:271px;left:66px;\" src=\"/dakar2026/en/static/_content/17-caption-1.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:334px;left:37px;\" src=\"/dakar2026/en/static/_content/17-text-1.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:431px;left:35px;\" src=\"/dakar2026/en/static/_content/17-text-2.png\"/>\n      <img class=\"abs halfScaleC 17-box-icon\" style=\"top:506px;left:58px;\" src=\"/dakar2026/en/static/_content/17-icon-date.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:598px;left:62px;\" src=\"/dakar2026/en/static/_content/17-icon-text-1.png\"/>\n      <img class=\"abs halfScaleC 17-box-icon\" style=\"top:634px;left:58px;\" src=\"/dakar2026/en/static/_content/17-icon-location.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:724px;left:49px;\" src=\"/dakar2026/en/static/_content/17-icon-text-2.png\"/>\n\n      <img class=\"abs halfScale 17-box\" style=\"top:239px;left:219px;\" src=\"/dakar2026/en/static/_content/17-box-2.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:271px;left:262px;\" src=\"/dakar2026/en/static/_content/17-caption-2.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:334px;left:236px;\" src=\"/dakar2026/en/static/_content/17-text-3.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:431px;left:237px;\" src=\"/dakar2026/en/static/_content/17-text-4.png\"/>\n      <img class=\"abs halfScaleC 17-box-icon\" style=\"top:506px;left:259px;\" src=\"/dakar2026/en/static/_content/17-icon-date.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:598px;left:258px;\" src=\"/dakar2026/en/static/_content/17-icon-text-3.png\"/>\n      <img class=\"abs halfScaleC 17-box-icon\" style=\"top:634px;left:259px;\" src=\"/dakar2026/en/static/_content/17-icon-location.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:724px;left:233px;\" src=\"/dakar2026/en/static/_content/17-icon-text-4.png\"/>\n\n      <img class=\"abs halfScale 17-box\" style=\"top:239px;left:417px;\" src=\"/dakar2026/en/static/_content/17-box-3.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:271px;left:461px;\" src=\"/dakar2026/en/static/_content/17-caption-3.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:334px;left:436px;\" src=\"/dakar2026/en/static/_content/17-text-5.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:400px;left:435px;\" src=\"/dakar2026/en/static/_content/17-text-6.png\"/>\n      <img class=\"abs halfScaleC 17-box-icon\" style=\"top:506px;left:455px;\" src=\"/dakar2026/en/static/_content/17-icon-date.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:598px;left:459px;\" src=\"/dakar2026/en/static/_content/17-icon-text-5.png\"/>\n      <img class=\"abs halfScaleC 17-box-icon\" style=\"top:634px;left:455px;\" src=\"/dakar2026/en/static/_content/17-icon-location.png\"/>\n      <img class=\"abs halfScale 17-box\" style=\"top:724px;left:446px;\" src=\"/dakar2026/en/static/_content/17-icon-text-6.png\"/>\n  \n      <img class=\"abs halfScaleC 17-image\" style=\"top:-56px;left:181px;\" src=\"/dakar2026/en/static/_content/17-image-1.png\"/>\n      <img class=\"abs halfScaleC 17-image\" style=\"top:-2px;left:420px;\" src=\"/dakar2026/en/static/_content/17-image-2.png\"/>\n\n      <img class=\"abs halfScale 17-bottom-bar\" style=\"top:835px;left:0px;\" src=\"/dakar2026/en/static/_content/17-bottom-bar-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim.staggerFromTo(cOf(\"17-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"17-image\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4)\n          .staggerFromTo(cOf(\"17-box\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1.6)\n          .staggerFromTo(cOf(\"17-box-icon\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 2.5);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Ceremonies  Contents  17  Ceremonies Everything you need to know about the Opening and Closing Ceremonies.  Welcome Session  Opening Ceremony  Closing Ceremony  The Welcome Session is an opportunity to get together with all the other athletes at the start of the Games.  One of the most iconic moments of any Games, the Opening Ceremony is the official starting point of Dakar 2026.  The Closing Ceremony is held to mark the official ending of the Games.  You will get a sneak peak of what to expect during Dakar 2026 and be treated to Senegalese artistic and musical performances.  All athletes are invited to take part in the ceremony and the athletes’ parade.  If you’re still in Dakar, all athletes are invited to take part in the ceremony and the Farewell Party that follows.  When is it?  When is it?  When is it?  30 October, time TBC.  31 October at 6:30 p.m.  13 November at 6 p.m.  Where is it?  Where is it?  Where is it?  Youth Olympic Village Plaza.  Abdoulaye Wade Stadium, located just 800m from the Village.  Youth Olympic Village Plaza.  your yog essentials"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n\n      <img class=\"abs halfScale 18-title\" style=\"top:207px;left:219px;\" src=\"/dakar2026/en/static/_content/18-title-1.png\"/>\n      <img class=\"abs halfScale 18-title\" style=\"top:288px;left:219px;\" src=\"/dakar2026/en/static/_content/18-title-2.png\"/>\n      <img class=\"abs halfScale 18-title\" style=\"top:381px;left:219px;\" src=\"/dakar2026/en/static/_content/18-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(19);\" style=\"top:480px; left:216px; width:236px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(20);\" style=\"top:513px; left:216px; width:236px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(21);\" style=\"top:546px; left:216px; width:236px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(22);\" style=\"top:580px; left:216px; width:236px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(23);\" style=\"top:614px; left:216px; width:236px; height:22px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.staggerFromTo(cOf(\"18-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Life in the Village  life in the village Get to know your home away from home. 19  Youth Olympic Village map  20  Accommodation  21  Village services  22  Athlete365 House  23  Eating and drinking  18"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 19-title\" style=\"top:87px;left:21px;\" src=\"/dakar2026/en/static/_content/19-title-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Training Area  Legend Team Processing Center  Training Area  Multifunction Building  Village Plaza  Transport Mall  Residental Buildings  Workforce/Supply Chain  Fitness Center  Dining Hall  Polyclinic  Meeting Hall  Operation Building  PSA  VSA  Security perimeter  VSA Vehicule Screen Area  Residental zone  PSA Pedestrian Screen Area  PSA VSA  services and operations Resident Center Concessions Merchandising Laundry Sport Athlete Education Programme Accreditation Check Equipment Storage Multifaith Room Lost & Found Guest Pass Center NOC Services Center  LIFE IN THE VILLAGE  PSA  LEGEND  Team Processing Center  Residential Buildings  Village Plaza  Transport Mall  Fitness Center  Polyclinic  Operation Building  VSA Vehicule screen area  PSA Pedestrian screen area  ACCREDITATION CHECK  EQUIPEMENT STORAGE  MULTIFAITH ROOM  LOST & FOUND  GUEST PASS CENTER  NOC SERVICES CENTER  Youth Olympic Village Map  Multifunction Building  Workforce / Supply Chain  Dining Hall  Meeting Hall  Security perimeter  Residential zone  RESIDENT CENTER  CONCESSIONS  MERCHANDISING  LAUNDRY  SPORT  ATHLETE EDUCATION PROGRAM  SERVICES AND OPERATIONS  Get Ready Pack: Dakar 2026 | Youth Olympic Village map  Contents  19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 20-title\" style=\"top:99px;left:21px;\" src=\"/dakar2026/en/static/_content/20-title-1.png\"/>\n      <img class=\"abs halfScale 20-title\" style=\"top:161px;left:21px;\" src=\"/dakar2026/en/static/_content/20-sub-1.png\"/>\n      \n      <img class=\"abs halfScaleC 20-icon\" style=\"top:372px;left:-4px;\" src=\"/dakar2026/en/static/_content/20-icon-1.png\"/>\n      <img class=\"abs halfScale 20-caption\" style=\"top:416px;left:78px;\" src=\"/dakar2026/en/static/_content/20-caption-1.png\"/>\n      <img class=\"abs halfScaleC 20-icon\" style=\"top:433px;left:-4px;\" src=\"/dakar2026/en/static/_content/20-icon-2.png\"/>\n      <img class=\"abs halfScale 20-caption\" style=\"top:475px;left:78px;\" src=\"/dakar2026/en/static/_content/20-caption-2.png\"/>\n      <img class=\"abs halfScaleC 20-icon\" style=\"top:492px;left:-4px;\" src=\"/dakar2026/en/static/_content/20-icon-3.png\"/>\n      <img class=\"abs halfScale 20-caption\" style=\"top:534px;left:78px;\" src=\"/dakar2026/en/static/_content/20-caption-3.png\"/>\n      <img class=\"abs halfScaleC 20-icon\" style=\"top:548px;left:-4px;\" src=\"/dakar2026/en/static/_content/20-icon-4.png\"/>\n      <img class=\"abs halfScale 20-caption\" style=\"top:592px;left:78px;\" src=\"/dakar2026/en/static/_content/20-caption-4.png\"/>\n      <img class=\"abs halfScaleC 20-icon\" style=\"top:605px;left:-4px;\" src=\"/dakar2026/en/static/_content/20-icon-5.png\"/>\n      <img class=\"abs halfScale 20-caption\" style=\"top:651px;left:78px;\" src=\"/dakar2026/en/static/_content/20-caption-5.png\"/>\n      <img class=\"abs halfScaleC 20-icon\" style=\"top:665px;left:-4px;\" src=\"/dakar2026/en/static/_content/20-icon-6.png\"/>\n      <img class=\"abs halfScale 20-caption\" style=\"top:708px;left:78px;\" src=\"/dakar2026/en/static/_content/20-caption-6.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.staggerFromTo(cOf(\"20-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"20-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)\n          .staggerFromTo(cOf(\"20-caption\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.5);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Accommodation  Contents  Accommodation What to expect in your room in the Youth Olympic Village. All athletes at Dakar 2026 will be staying in the Youth Olympic Village, your home for the duration of the Games. The Village is one of the most unique experiences of any Games, giving you the chance to meet athletes from all over the world and make friends for life.  Your room  When you get to the Village, have gone through security and picked up your accreditation, you will be taken to your room, where you will stay for your time at the Games. Each room will have up to 4 beds, and each resident will have: 1 bath towel  1 hand towel  1 wardrobe  5 hangers  2 laundry bags  1 fan Shared bathrooms will be available on your floor.  LIFE IN THE VILLAGE  20"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 21-title\" style=\"top:99px;left:21px;\" src=\"/dakar2026/en/static/_content/21-title-1.png\"/>\n      <img class=\"abs halfScale 21-title\" style=\"top:150px;left:21px;\" src=\"/dakar2026/en/static/_content/21-title-2.png\"/>\n      <img class=\"abs halfScale 21-title\" style=\"top:202px;left:21px;\" src=\"/dakar2026/en/static/_content/21-title-3.png\"/>\n      <img class=\"abs halfScale 21-title\" style=\"top:254px;left:21px;\" src=\"/dakar2026/en/static/_content/21-title-4.png\"/>\n      <img class=\"abs halfScale 21-title\" style=\"top:317px;left:20px;\" src=\"/dakar2026/en/static/_content/21-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/dakar-2026/dakar-2026-youth-olympic-village-services\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 47-btn pointer\" style=\"top:354px;left:-43px;\" src=\"/dakar2026/en/static/_content/21-button-1.png\"/>\n      </a>\n      \n      <img class=\"abs halfScale 21-box\" style=\"top:97px;left:268px;\" src=\"/dakar2026/en/static/_content/21-box-1.png\"/>\n      <img class=\"abs halfScale 21-bottom-bar\" style=\"top:836px;left:0px;\" src=\"/dakar2026/en/static/_content/21-bottom-bar-1.png\"/>\n      <img class=\"abs halfScale 21-image\" style=\"top:443px;left:148px;\" src=\"/dakar2026/en/static/_content/21-image-1.png\"/>\n\n      <img class=\"abs halfScaleC 21-icon\" style=\"top:92px;left:264px;\" src=\"/dakar2026/en/static/_content/21-icon-1.png\" />\n      <img class=\"abs halfScaleC 21-icon\" style=\"top:192px;left:264px;\" src=\"/dakar2026/en/static/_content/21-icon-2.png\" />\n      <img class=\"abs halfScaleC 21-icon\" style=\"top:294px;left:264px;\" src=\"/dakar2026/en/static/_content/21-icon-3.png\" />\n      <img class=\"abs halfScaleC 21-icon\" style=\"top:398px;left:264px;\" src=\"/dakar2026/en/static/_content/21-icon-4.png\" />\n      <img class=\"abs halfScaleC 21-icon\" style=\"top:499px;left:264px;\" src=\"/dakar2026/en/static/_content/21-icon-5.png\" />\n      <img class=\"abs halfScaleC 21-icon\" style=\"top:600px;left:264px;\" src=\"/dakar2026/en/static/_content/21-icon-6.png\" />\n      <img class=\"abs halfScaleC 21-icon\" style=\"top:704px;left:264px;\" src=\"/dakar2026/en/static/_content/21-icon-7.png\" />\n\n      <img class=\"abs halfScale 21-text\" style=\"top:133px;left:392px;\" src=\"/dakar2026/en/static/_content/21-caption-1.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:149px;left:392px;\" src=\"/dakar2026/en/static/_content/21-text-1.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:241px;left:392px;\" src=\"/dakar2026/en/static/_content/21-caption-2.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:258px;left:392px;\" src=\"/dakar2026/en/static/_content/21-text-2.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:337px;left:392px;\" src=\"/dakar2026/en/static/_content/21-caption-3.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:354px;left:392px;\" src=\"/dakar2026/en/static/_content/21-text-3.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:446px;left:392px;\" src=\"/dakar2026/en/static/_content/21-caption-4.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:462px;left:392px;\" src=\"/dakar2026/en/static/_content/21-text-4.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:554px;left:392px;\" src=\"/dakar2026/en/static/_content/21-caption-5.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:571px;left:392px;\" src=\"/dakar2026/en/static/_content/21-text-5.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:663px;left:392px;\" src=\"/dakar2026/en/static/_content/21-caption-6.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:680px;left:392px;\" src=\"/dakar2026/en/static/_content/21-text-6.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:758px;left:392px;\" src=\"/dakar2026/en/static/_content/21-caption-7.png\"/>\n      <img class=\"abs halfScale 21-text\" style=\"top:775px;left:392px;\" src=\"/dakar2026/en/static/_content/21-text-7.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.staggerFromTo(cOf(\"21-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"21-box\"), 1, {opacity:0, x: 120}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"21-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .staggerFromTo(cOf(\"21-icon\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.8)\n          .staggerFromTo(cOf(\"21-text\"), 0.6, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.7);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Youth Olympic Village services Here’s what you will find in the Youth Olympic Village.  FIND OUT MORE  Get Ready Pack: Dakar 2026 | Youth Olympic Village services  Polyclinic  Medical clinic with a range of services including emergency care, physiotherapy, basic dental, pharmacy and counselling. There is also a first-aid station located in the Village Plaza.  Fitness Centre  Gym with areas for weight training, cardio, stretching and mobility, cross-training and recovery.  Laundry  Self-service laundry facilities with washing machines and dryers. Detergent will be provided and volunteers will be on hand to assist you if needed.  Resident Centre  Get assistance with any accommodation issues, including housekeeping requests, emergency maintenance and lost property.  village plaza  A central space to relax and meet others, with cultural activities and entertainment.  Multifaith room  A quiet space for meditation and worship.  Common areas  Air-conditioned reading room and games room.  LIFE IN THE VILLAGE  21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 22-title\" style=\"top:326px;left:21px;\" src=\"/dakar2026/en/static/_content/22-title-1.png\"/>\n      <img class=\"abs halfScale 22-title\" style=\"top:379px;left:23px;\" src=\"/dakar2026/en/static/_content/22-title-2.png\"/>\n      <img class=\"abs halfScale 22-title\" style=\"top:441px;left:20px;\" src=\"/dakar2026/en/static/_content/22-sub-1.png\"/>\n\n      <img class=\"abs halfScale halfpulse 22-box\" style=\"top:325px;left:269px;\" src=\"/dakar2026/en/static/_content/22-box-1.png\"/>\n      <img class=\"abs halfScaleC 22-icon\" style=\"top:321px;left:249px;\" src=\"/dakar2026/en/static/_content/22-icon-1.png\"/>\n      <img class=\"abs halfScale 22-caption\" style=\"top:352px;left:348px;\" src=\"/dakar2026/en/static/_content/22-caption-1.png\"/>\n      <img class=\"abs halfScale 22-caption\" style=\"top:389px;left:348px;\" src=\"/dakar2026/en/static/_content/22-text-1.png\"/>\n\n      <div class=\"abs\" style=\"top:448px;left:294px;height:50px;width:215px;overflow:hidden;\">\n        <div class=\"abs pointer\" onclick=\"Publish.goToPage(24);\" style=\"top:-5px;left:-14px;width:232px;height:56px;\">\n          <img class=\"abs halfScaleC 22-button\" id=\"button\" style=\"top:-8px;left:7px;\" src=\"/dakar2026/en/static/_content/22-button-1.png\"/>\n        </div>\n      </div>\n\n      <img class=\"abs halfScaleC 22-icon\" style=\"top:497px;left:242px;\" src=\"/dakar2026/en/static/_content/22-icon-2.png\"/>\n      <img class=\"abs halfScaleC 22-icon\" style=\"top:567px;left:242px;\" src=\"/dakar2026/en/static/_content/22-icon-3.png\"/>\n      <img class=\"abs halfScaleC 22-icon\" style=\"top:634px;left:242px;\" src=\"/dakar2026/en/static/_content/22-icon-4.png\"/>\n      <img class=\"abs halfScaleC 22-icon\" style=\"top:700px;left:242px;\" src=\"/dakar2026/en/static/_content/22-icon-5.png\"/>\n\n      <img class=\"abs halfScale 22-caption\" style=\"top:526px;left:328px;\" src=\"/dakar2026/en/static/_content/22-caption-2.png\"/>\n      <img class=\"abs halfScale 22-text\" style=\"top:543px;left:328px;\" src=\"/dakar2026/en/static/_content/22-text-2.png\"/>\n\n      <img class=\"abs halfScale 22-caption\" style=\"top:594px;left:328px;\" src=\"/dakar2026/en/static/_content/22-caption-3.png\"/>\n      <img class=\"abs halfScale 22-text\" style=\"top:612px;left:328px;\" src=\"/dakar2026/en/static/_content/22-text-3.png\"/>\n\n      <img class=\"abs halfScale 22-caption\" style=\"top:661px;left:328px;\" src=\"/dakar2026/en/static/_content/22-caption-4.png\"/>\n      <img class=\"abs halfScale 22-text\" style=\"top:679px;left:328px;\" src=\"/dakar2026/en/static/_content/22-text-4.png\"/>\n\n      <img class=\"abs halfScale 22-caption\" style=\"top:728px;left:328px;\" src=\"/dakar2026/en/static/_content/22-caption-5.png\"/>\n      <img class=\"abs halfScale 22-text\" style=\"top:746px;left:328px;\" src=\"/dakar2026/en/static/_content/22-text-5.png\"/>\n\n      <div class=\"abs\" style=\"top:780px;left:294px;height:50px;width:180px;overflow:hidden;\">\n        <a href=\"https://www.olympics.com/athlete365/articles/dakar-2026/everything-you-need-to-know-about-athlete365-house-at-dakar-2026\" target=\"_blank\">\n          <img class=\"abs halfScaleC 22-button\" id=\"button\" style=\"top:-9px;left:-30px;\" src=\"/dakar2026/en/static/_content/22-button-1.png\"/>\n        </a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.staggerFromTo(cOf(\"22-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"22-box\"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .staggerFromTo(cOf(\"22-caption\"), 0.7, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.9)\n          .staggerFromTo(cOf(\"22-text\"), 0.7, {opacity:0, y: 15}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 2.1)\n          .staggerFromTo(cOf(\"22-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.2)\n          .fromTo(cOf(\"22-button\"), 0.8, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 3);\n          setTimeout(function(){\n            addPulse(\"button\")\n          }, 3000)\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n          removePulse(\"button\")\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete365 House  Athlete365 House Everything you need to know about Athlete365 House – the centre of Youth Olympic Village life. Athlete365 House will play a key role in your time at Dakar 2026 as a space to learn, have fun and meet others. Here’s everything you can expect.  Learn Athlete365 House is the home of the Athlete Education Programme, which all athletes must complete during the Games.  FIND OUT MORE  Play  Have fun and compete against others on our arcade machines and video games.  Capture Commemorate your time at the Games in our photo kiosk.  Watch Sit down and catch all the live action on the big screens.  Meet Speak to members of the IOC Athletes’ Commission, Athlete Role Models and other IOC experts.  FIND OUT MORE LIFE IN THE VILLAGE  22"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 23-title\" style=\"top:99px;left:20px;\" src=\"/dakar2026/en/static/_content/23-title-1.png\"/>\n      <img class=\"abs halfScale 23-title\" style=\"top:150px;left:20px;\" src=\"/dakar2026/en/static/_content/23-title-2.png\"/>\n      <img class=\"abs halfScale 23-title\" style=\"top:215px;left:20px;\" src=\"/dakar2026/en/static/_content/23-sub-1.png\"/>\n\n      <img class=\"abs halfScale 23-text\" style=\"top:427px;left:22px;\" src=\"/dakar2026/en/static/_content/23-text-1.png\"/>\n      <img class=\"abs halfScaleC 23-icon\" style=\"top:372px;left:109px;\" src=\"/dakar2026/en/static/_content/23-icon-1.png\"/>\n\n      <img class=\"abs halfScale 23-text\" style=\"top:520px;left:22px;\" src=\"/dakar2026/en/static/_content/23-text-2.png\"/>\n      <img class=\"abs halfScaleC 23-icon\" style=\"top:472px;left:155px;\" src=\"/dakar2026/en/static/_content/23-icon-2.png\"/>\n\n      <img class=\"abs halfScale 23-text\" style=\"top:630px;left:22px;\" src=\"/dakar2026/en/static/_content/23-text-3.png\"/>\n      <img class=\"abs halfScaleC 23-icon\" style=\"top:562px;left:225px;\" src=\"/dakar2026/en/static/_content/23-icon-3.png\"/>\n\n      <img class=\"abs halfScale 23-text\" style=\"top:713px;left:22px;\" src=\"/dakar2026/en/static/_content/23-text-4.png\"/>\n      <img class=\"abs halfScaleC 23-icon\" style=\"top:640px;left:315px;\" src=\"/dakar2026/en/static/_content/23-icon-4.png\"/>\n\n      <img class=\"abs halfScale 23-text\" style=\"top:789px;left:22px;\" src=\"/dakar2026/en/static/_content/23-text-5.png\"/>\n      <img class=\"abs halfScaleC 23-icon\" style=\"top:703px;left:419px;\" src=\"/dakar2026/en/static/_content/23-icon-5.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim.staggerFromTo(cOf(\"23-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"23-text\"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.6)\n          .staggerFromTo(cOf(\"23-icon\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.7);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Eating and drinking  Eating and drinking Your food and beverage options have been carefully designed to offer you high-quality meals tailored to your dietary and nutritional requirements.  The Dining Hall will be open from 5 a.m. to 11 p.m. every day Specific menus available for breakfast (5 a.m. to 11 a.m.), lunch (11 a.m. to 6 p.m.) and dinner (6 p.m. to 11 p.m.)  Diverse selection including Senegalese and West African cuisine  Vegetarian, vegan and gluten-free options available  Water, local juices, and soft drinks from Coca-Cola available  LIFE IN THE VILLAGE  23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n\n      <img class=\"abs halfScale 24-title\" style=\"top:126px;left:217px;\" src=\"/dakar2026/en/static/_content/24-title-1.png\"/>\n      <img class=\"abs halfScale 24-title\" style=\"top:208px;left:219px;\" src=\"/dakar2026/en/static/_content/24-title-2.png\"/>\n      <img class=\"abs halfScale 24-title\" style=\"top:288px;left:219px;\" src=\"/dakar2026/en/static/_content/24-title-3.png\"/>\n      <img class=\"abs halfScale 24-title\" style=\"top:381px;left:219px;\" src=\"/dakar2026/en/static/_content/24-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(25);\" style=\"top:480px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(26);\" style=\"top:513px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(27);\" style=\"top:546px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(28);\" style=\"top:580px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(29);\" style=\"top:614px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(30);\" style=\"top:648px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(31);\" style=\"top:680px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(32);\" style=\"top:714px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(33);\" style=\"top:746px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(34);\" style=\"top:780px; left:216px; width:212px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(37);\" style=\"top:814px; left:216px; width:212px; height:22px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.staggerFromTo(cOf(\"24-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme  Athlete Education Programme Helping you maximise your Youth Olympic Games experience. 25  Introduction  26  Overview  27  Learning courses  28  PinQuest  29  Integrity  30  Career support  31  Health and well-being  32  Digital and media  33  Olympic Impact  34  Athlete Role Models  37  Inside Sport Sessions  24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 25-title\" style=\"top:98px;left:21px;\" src=\"/dakar2026/en/static/_content/25-title-1.png\"/>\n      <img class=\"abs halfScale 25-title\" style=\"top:151px;left:23px;\" src=\"/dakar2026/en/static/_content/25-title-2.png\"/>\n      <img class=\"abs halfScale 25-title\" style=\"top:214px;left:20px;\" src=\"/dakar2026/en/static/_content/25-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim.staggerFromTo(cOf(\"25-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Introduction  What is the Athlete Education Programme? The Athlete Education Programme (AEP) is one of the main pillars of the Youth Olympic Games experience. The Youth Olympic Games provide a unique opportunity for you to compete on an international stage, but also to start developing new skills and experience off the field of play. The AEP is designed to equip all participating athletes with the  Athlete EDUCATION PROGRAMME  knowledge, skills and mindset needed to excel, both at the Games and beyond. If you're an entourage member such as a coach, physio, medical practitioner, nutritionist, family member or NOC staff, the programme will provide you  with the tools you need to lead your athletes to success on the international stage.  25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 26-title\" style=\"top:80px;left:21px;\" src=\"/dakar2026/en/static/_content/26-sub-1.png\"/>\n      <img class=\"abs halfScale 26-title\" style=\"top:98px;left:21px;\" src=\"/dakar2026/en/static/_content/26-title-1.png\"/>\n      <img class=\"abs halfScale 26-title\" style=\"top:163px;left:20px;\" src=\"/dakar2026/en/static/_content/26-sub-2.png\"/>\n\n      <img class=\"abs halfScaleC 26-icon\" style=\"top:452px;left:2px;\" src=\"/dakar2026/en/static/_content/26-icon-1.png\"/>\n      <img class=\"abs halfScale 26-text\" style=\"top:481px;left:89px;\" src=\"/dakar2026/en/static/_content/26-text-1.png\"/>\n      <img class=\"abs halfScaleC 26-icon\" style=\"top:548px;left:2px;\" src=\"/dakar2026/en/static/_content/26-icon-2.png\"/>\n      <img class=\"abs halfScale 26-text\" style=\"top:574px;left:89px;\" src=\"/dakar2026/en/static/_content/26-text-2.png\"/>\n      <img class=\"abs halfScaleC 26-icon\" style=\"top:656px;left:2px;\" src=\"/dakar2026/en/static/_content/26-icon-3.png\"/>\n      <img class=\"abs halfScale 26-text\" style=\"top:684px;left:89px;\" src=\"/dakar2026/en/static/_content/26-text-3.png\"/>\n      <img class=\"abs halfScaleC 26-icon\" style=\"top:740px;left:2px;\" src=\"/dakar2026/en/static/_content/26-icon-4.png\"/>\n      <img class=\"abs halfScale 26-text\" style=\"top:774px;left:89px;\" src=\"/dakar2026/en/static/_content/26-text-4.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.staggerFromTo(cOf(\"26-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"26-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.6)\n          .staggerFromTo(cOf(\"26-text\"), 0.7, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.7);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Athlete Education Programme: Overview  Contents  Athlete Education Programme:  Overview  The Athlete Education Programme (AEP) consists of multiple activities, both before and during the Games. Pre-Games  Before you travel to Dakar, please complete our Athlete365 Learning course, Mastering your Sporting Journey – available for athletes and entourage members.  During the Games  When you’re in Dakar, you are requested to set aside four hours (non-consecutive) to complete the various AEP activities, located at Athlete365 House. The AEP is delivered through four formats: Learning activities: Seven interactive activities teaching you about various important topics for your career and life ahead.  PinQuest: A mobile game that challenges you to complete the seven learning activities, boost your Olympic knowledge, and win exclusive Olympic prizes.  Athlete Role Models: Experienced Olympians and elite athletes who will be on-site throughout the Games to provide mentorship, learning and inspiration.  Inside Sport Sessions: An opportunity to learn from Athlete Role Models and other athletes on topics specific to your sport.  Athlete EDUCATION PROGRAMME  26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 27-title\" style=\"top:80px;left:21px;\" src=\"/dakar2026/en/static/_content/27-sub-1.png\"/>\n      <img class=\"abs halfScale 27-title\" style=\"top:98px;left:21px;\" src=\"/dakar2026/en/static/_content/27-title-1.png\"/>\n      <img class=\"abs halfScale 27-title\" style=\"top:152px;left:21px;\" src=\"/dakar2026/en/static/_content/27-title-2.png\"/>\n      <img class=\"abs halfScale 27-title\" style=\"top:214px;left:20px;\" src=\"/dakar2026/en/static/_content/27-sub-2.png\"/>\n\n      <img class=\"abs halfScaleC 27-icon\" style=\"top:440px;left:75px;\" src=\"/dakar2026/en/static/_content/27-icon-1.png\"/>\n      <img class=\"abs halfScale 27-text\" style=\"top:581px;left:125px;\" src=\"/dakar2026/en/static/_content/27-subtext-1.png\"/>\n      <img class=\"abs halfScale 27-text\" style=\"top:605px;left:39px;\" src=\"/dakar2026/en/static/_content/27-text-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/learning/mastering-your-sporting-journey-for-young-athletes\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 27-btn pointer\" style=\"top:725px;left:24px;\" src=\"/dakar2026/en/static/_content/27-button-1.png\"/>\n      </a>\n\n      <img class=\"abs halfScale 27-line\" style=\"top:522px;left:305px;\" src=\"/dakar2026/en/static/_content/27-line-1.png\"/>\n\n      <img class=\"abs halfScaleC 27-icon\" style=\"top:440px;left:370px;\" src=\"/dakar2026/en/static/_content/27-icon-2.png\"/>\n      <img class=\"abs halfScale 27-text\" style=\"top:581px;left:379px;\" src=\"/dakar2026/en/static/_content/27-subtext-2.png\"/>\n      <img class=\"abs halfScale 27-text\" style=\"top:605px;left:331px;\" src=\"/dakar2026/en/static/_content/27-text-2.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/learning/mastering-your-sporting-journey-for-athletes-entourage-members\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 27-btn pointer\" style=\"top:725px;left:317px;\" src=\"/dakar2026/en/static/_content/27-button-1.png\"/>\n      </a>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.staggerFromTo(cOf(\"27-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"27-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.6)\n          .staggerFromTo(cOf(\"27-text\"), 0.7, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.8)\n          .fromTo(cOf(\"27-line\"), 0.7, {opacity:0, x: -20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.8);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Athlete Education Programme: Learning courses  Contents  Athlete Education Programme:  Mastering Your Sporting Journey Our learning course sets athletes and entourage members up for success at the Youth Olympic Games – and beyond. Ahead of Dakar 2026, you are asked to complete the Athlete365 Learning course, Mastering your Sporting Journey. Two bespoke courses have been created for both athletes and entourage members.  Athletes  Entourage members  If you are an athlete, this course will teach you how to build your mental fitness, protect yourself and others, and keep sport clean.  For entourage members – anyone supporting an athlete on their journey to the YOG – this course will teach you how to support your athlete’s mental health, foster a safe sporting environment and protect the integrity of sport.  The course is available in nine languages.  The course is available in six languages.  TAKE THE COURSE  Athlete EDUCATION PROGRAMME  TAKE THE COURSE  27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 28-title\" style=\"top:110px;left:20px;\" src=\"/dakar2026/en/static/_content/28-title-1.png\"/>\n        <img class=\"abs halfScale 28-sub\" style=\"top:232px;left:20px;\" src=\"/dakar2026/en/static/_content/28-sub-1.png\"/>\n\n        <div class=\"addContentLink\" style=\"top:83px;left:503px;width:64px;height:66px;\">\n          <a href=\"https://qrco.de/bcFFH9\" target=\"_blank\"></a>\n        </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.fromTo(cOf(\"28-title\"), 0.8, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.8)\n          .fromTo(cOf(\"28-sub\"), 0.8, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();          \n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Athlete Education Programme: PinQuest  Contents  28  Download PinQuest here  Your guide through the Athlete Education Programme – and chance to win exclusive Olympic prizes! PinQuest is a mobile game that will guide you through the in-person Athlete Education Programme learning activities. Complete the activities to win an exclusive pin collection and boost your Olympic knowledge for another special prize!  Step 1  Step 2  Step 3  Before you arrive at Athlete365 House to start the Athlete Education Programme, download the PinQuest app and register or sign in using your Olympic ID.  Use PinQuest to navigate the seven learning activities and validate your progress within the app.  Continue your PinQuest adventure by testing your Olympic knowledge.  Athlete EDUCATION PROGRAMME  When all activities are complete, head to the PinQuest desk to pick up your exclusive pin box.  If you accumulate 10,000 points, head to the desk for another special prize – an Athlete365 bucket hat!"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 29-title\" style=\"top:80px;left:20px;\" src=\"/dakar2026/en/static/_content/29-sub-1.png\"/>\n        <img class=\"abs halfScale 29-title\" style=\"top:103px;left:20px;\" src=\"/dakar2026/en/static/_content/29-title-1.png\"/>\n        <img class=\"abs halfScale 29-title\" style=\"top:166px;left:20px;\" src=\"/dakar2026/en/static/_content/29-sub-2.png\"/>\n        <img class=\"abs halfScaleC halfpulse animatedpulse 29-button-1\" style=\"top:301px;left:170px;\" src=\"/dakar2026/en/static/_content/29-button-1.png\"/>\n        \n        <div class=\"abs pointer\" onclick=\"Publish.goToPage(42);\" style=\"top:371px;left:383px;width:116px;height:46px;border-radius:30px;\">\n          <img class=\"abs halfScaleC halfpulse animatedpulse 29-button-2\" src=\"/dakar2026/en/static/_content/29-button-2.png\"/>\n        </div>\n\n        <a class=\"abs\" href=\"https://www.olympics.com/athlete365/articles/pcm/meet-your-believe-in-sport-ambassadors-for-dakar-2026\" style=\"top:323px;left:254px;width:172px;height:42px;border-radius:30px;\" target=\"_blank\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.8, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Integrity  Athlete Education Programme:  Integrity  We all have a responsibility to protect clean sport. This learning activity will teach you about the prevention of competition manipulation and anti-doping.  29  Believe in Sport  Together for Clean Sport  Take part in an interactive game featuring various scenarios that will help you understand the Code of Conduct on Competition Manipulation.  Engage with representatives from the World Anti-Doping Agency (WADA) and the International Testing Agency (ITA) to learn about antidoping rules and the resources available to support you.  You will meet the Believe in Sport athlete ambassadors, hear real-life stories and have the chance to ask any questions.  Get to know the Believe in Sport ambassadors  You will have a choice of three interactive activities, including a simulation of the doping control process, and the chance to speak to current and retired athletes about clean sport.  Anti-doping at Dakar 2026  Athlete EDUCATION PROGRAMME"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 30-title\" style=\"top:80px;left:20px;\" src=\"/dakar2026/en/static/_content/30-sub-1.png\"/>\n        <img class=\"abs halfScale 30-title\" style=\"top:100px;left:20px;\" src=\"/dakar2026/en/static/_content/30-title-1.png\"/>\n        <img class=\"abs halfScale 30-title\" style=\"top:163px;left:20px;\" src=\"/dakar2026/en/static/_content/30-sub-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          }, 2000)\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Career support  Athlete Education Programme:  Career support It’s important to prepare for a life beyond sport. This learning activity will help you discover new skills and the support programmes available from Olympic Solidarity. Athlete365 Career+ Unlock your Potential, supported by Allianz Collaborate with other athletes and entourage members to solve puzzles, uncover and leverage skills for life beyond sport, and learn how to balance your life on and off the field of play.  Athlete EDUCATION PROGRAMME  Olympic Solidarity Get involved in a game of snookball – a cross between snooker and football – to learn about Olympic Solidarity and the training and education opportunities available to you through your National Olympic Committee.  30"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 31-title\" style=\"top:80px;left:20px;\" src=\"/dakar2026/en/static/_content/30-sub-1.png\"/>\n        <img class=\"abs halfScale 31-title\" style=\"top:103px;left:20px;\" src=\"/dakar2026/en/static/_content/31-title-1.png\"/>\n        <img class=\"abs halfScale 31-title\" style=\"top:166px;left:20px;\" src=\"/dakar2026/en/static/_content/31-sub-2.png\"/>\n        <img class=\"abs halfScaleC halfpulse animatedpulse 31-button\" style=\"top:727px;left:196px;\" src=\"/dakar2026/en/static/_content/31-button-1.png\"/>\n\n        <div class=\"abs pointer\" onclick=\"Publish.goToPage(39);\" style=\"top:748px;left:258px;width:124px;height:43px;border-radius:30px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.staggerFromTo(cOf(\"31-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Health and well-being  31  Athlete Education Programme:  Health and Well-being Your health and well-being matter, both on and off the field of play. This learning activity will help you build the skills to manage your physical and mental health and recognise concerning behaviours. Injury prevention  Meet experts who will show you practical exercises to help prevent injuries and perform at your best using the Get Set – Train Smarter app (more info on p46).  Mental health Take a moment to slow down, be mindful and discover simple ways to look after your mental well-being.  Mind, Body and Me  The Mind, Body and Me space is a welcoming area where you can take a break, learn something new and discover ways to support your health and well-being.  Safeguarding  Learn how to recognise healthy relationships, set personal boundaries and where to turn if something doesn't feel right. You can also speak to an IOC Safeguarding Officer if you need support.  Athlete EDUCATION PROGRAMME  How to seek help at Dakar 2026"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 32-title\" style=\"top:493px;left:20px;\" src=\"/dakar2026/en/static/_content/32-sub-1.png\"/>\n        <img class=\"abs halfScale 32-title\" style=\"top:513px;left:20px;\" src=\"/dakar2026/en/static/_content/32-title-1.png\"/>\n        <img class=\"abs halfScale 32-title\" style=\"top:577px;left:20px;\" src=\"/dakar2026/en/static/_content/32-sub-2.png\"/>\n    \n        <div class=\"abs\" style=\"top:653px;left:467px;height: 182px;width: 133px;overflow:hidden;\">\n          <img class=\"abs halfScale 32-box\" style=\"top:0px;left:0px;\" src=\"/dakar2026/en/static/_content/32-box-1.png\"/>\n          <img class=\"abs halfScaleC 32-button\" id=\"button\" style=\"top:126px;left:-47px;\" src=\"/dakar2026/en/static/_content/32-button-1.png\"/>\n          <a href=\"https://www.olympics.com/athlete365/learning/building-a-winning-personal-brand\" target=\"_blank\">\n            <div class=\"abs pointer\" style=\"top:139px;left:10px;width:114px;height:29px;border-radius:30px;\"></div>\n          </a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.staggerFromTo(cOf(\"32-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"32-box\"), 0.6, {opacity:0, y: 100}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"32-button\"), 0.8, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1.6);\n          setTimeout(function(){\n            addPulse(\"button\")\n          }, 3000)\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n          removePulse(\"button\")\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Athlete Education Programme: Digital and media  Contents  32  Athlete Education Programme:  Digital and media Want to explore sports broadcasting and digital storytelling? This learning activity will take you behind the scenes of live television and help you create your own content. Broadcast Lab  Go behind the scenes with Olympic Broadcasting Services (OBS) as you get a hands-on experience of live television. Rotate between the different stations and  Athlete EDUCATION PROGRAMME  understand how each role contributes to a successful sports broadcast.  Creators Studio Presented by The Olympic Channel, this interactive hub will  allow you to explore the world of digital storytelling, enhance your understanding of Olympics.com and create your own engaging content.  Want to build your personal brand? Check out our Athlete365 Learning course.  TAKE THE COURSE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 33-title\" style=\"top:386px;left:20px;\" src=\"/dakar2026/en/static/_content/33-sub-1.png\"/>\n        <img class=\"abs halfScale 33-title\" style=\"top:406px;left:20px;\" src=\"/dakar2026/en/static/_content/33-title-1.png\"/>\n        <img class=\"abs halfScale 33-title\" style=\"top:458px;left:20px;\" src=\"/dakar2026/en/static/_content/33-title-2.png\"/>\n        <img class=\"abs halfScale 33-title\" style=\"top:523px;left:21px;\" src=\"/dakar2026/en/static/_content/33-sub-2.png\"/>\n        \n        <img class=\"abs halfScale 33-icon\" style=\"top:710px;left:73px;\" src=\"/dakar2026/en/static/_content/33-icon-1.png\"/>\n        <img class=\"abs halfScale 33-icon\" style=\"top:710px;left:269px;\" src=\"/dakar2026/en/static/_content/33-icon-2.png\"/>\n        <img class=\"abs halfScale 33-icon\" style=\"top:710px;left:464px;\" src=\"/dakar2026/en/static/_content/33-icon-3.png\"/>\n        \n        <img class=\"abs halfScale 33-text\" style=\"top:772px;left:46px;\" src=\"/dakar2026/en/static/_content/33-text-1.png\"/>\n        <img class=\"abs halfScale 33-text\" style=\"top:772px;left:250px;\" src=\"/dakar2026/en/static/_content/33-text-2.png\"/>\n        <img class=\"abs halfScale 33-text\" style=\"top:772px;left:435px;\" src=\"/dakar2026/en/static/_content/33-text-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim.staggerFromTo(cOf(\"33-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"33-icon\"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n          .staggerFromTo(cOf(\"33-text\"), 1, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1.7);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Olympic Impact  Athlete Education Programme:  Olympic Impact presented by IOC Young Leaders Did you know that the IOC uses sport to create positive change in society? This learning activity will help you understand how sport can impact the wider world and how you can be a part of this effort. Meet the IOC Young Leaders, a group of inspiring young people supported by the IOC to leverage the power of sport in their communities. They will guide you through a series of interactive activities that will demonstrate how we can use sport to:  Improve health and well-being  Athlete EDUCATION PROGRAMME  Increase access to education  Build more inclusive communities  33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 34-title\" style=\"top:98px;left:20px;\" src=\"/dakar2026/en/static/_content/34-title-1.png\"/>\n        <img class=\"abs halfScale 34-sub\" style=\"top:161px;left:20px;\" src=\"/dakar2026/en/static/_content/34-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(cOf(\"34-title\"), 1, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"34-sub\"), 1, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Role Models  Athlete Role Models A crucial part of the Youth Olympic Games experience, Athlete Role Models will be on site throughout Dakar 2026 to offer first-hand mentorship and education. What are Athlete Role Models?  What will they be doing?  These experienced Olympians and elite athletes have been nominated by their International Federations to pass on their knowledge to you, the next generation.  • Athlete Education Programme learning activities • Inside Sport Sessions • Competitions and training • Victory ceremonies  At Dakar 2026, there will be at least one Athlete Role Model for each of the 25 competition and 10 engagement sports.  Meet your Athlete Role Models on the next page.  Athlete Role Models have been present at the Youth Olympic Games since the very first edition at Singapore 2010.  Athlete EDUCATION PROGRAMME  During Dakar 2026, each Athlete Role Model will be on site for a designated period of time to participate in:  34"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 35-title\" style=\"top:98px;left:20px;\" src=\"/dakar2026/en/static/_content/35-title-1.png\"/>\n        <img class=\"abs halfScale 35-title\" style=\"top:150px;left:20px;\" src=\"/dakar2026/en/static/_content/35-title-2.png\"/>\n        \n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:239px;left:21px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-1.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:239px;left:140px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-2.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:239px;left:260px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-3.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:239px;left:379px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-4.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:239px;left:499px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-5.png\"/>\n        \n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:387px;left:21px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-6.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:387px;left:140px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-7.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:387px;left:260px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-8.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:387px;left:379px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-9.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:387px;left:499px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-10.png\"/>\n        \n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:537px;left:20px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-11.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:537px;left:140px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-12.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:537px;left:260px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-13.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:537px;left:374px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-14.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:537px;left:499px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-15.png\"/>\n        \n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:684px;left:20px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-16.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:684px;left:140px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-17.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:684px;left:260px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-18.png\"/>\n        <img class=\"abs halfScale 35-rolemodel\" style=\"top:684px;left:379px;\" src=\"/dakar2026/en/static/_content/35-rolemodel-19.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim.staggerFromTo(cOf(\"35-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 0.8)\n          .staggerFromTo(cOf(\"35-rolemodel\"), 0.5, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.2);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Athlete Role Models  Contents  35  Meet your Athlete Role Models  Clarisse Agbegnenou  Omar Al Marzooqi  Stéphane Badji  Christopher Bak  Lisa Barbelin  France | Judo  United Arab Emirates | Equestrian  Senegal | Football  United States of America | Rowing  France | Archery  Asunción Batista  Rémy Bedi  Yves Bourhis  Jean-Pierre Bourhis  Darcy Bourne  Spain | Beach Handball  France | Golf  Senegal | Canoe Slalom  Senegal | Canoe Slalom  Great Britain | Hockey  Douglas Brose  Sheila Chajira  Doaa Elghobashy  Jomana Elsafy  Ruth Gbagbi  Brazil | Karate  Kenya | Rugby Sevens  Egypt | Beach Volleyball  Egypt | Shooting  Côte d'Ivoire | Taekwondo  Sonja Greinacher  Yasser Hefny  Zohra Nora Kehli  Khadija Krimi  Germany | 3x3 Basketball  Egypt | Modern Pentathlon  Algeria | Fencing  Tunisia | Rowing  Athlete EDUCATION PROGRAMME"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n        <img class=\"abs halfScale 36-title\" style=\"top:98px;left:20px;\" src=\"/dakar2026/en/static/_content/36-title-1.png\"/>\n        <img class=\"abs halfScale 36-title\" style=\"top:150px;left:20px;\" src=\"/dakar2026/en/static/_content/36-title-2.png\"/>\n        \n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:239px;left:21px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-1.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:239px;left:140px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-2.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:239px;left:260px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-3.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:239px;left:379px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-4.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:239px;left:499px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-5.png\"/>\n        \n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:387px;left:21px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-6.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:387px;left:140px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-7.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:387px;left:260px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-8.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:387px;left:379px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-9.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:387px;left:499px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-10.png\"/>\n        \n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:537px;left:20px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-11.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:537px;left:140px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-12.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:537px;left:260px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-13.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:537px;left:374px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-14.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:537px;left:499px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-15.png\"/>\n        \n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:684px;left:20px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-16.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:684px;left:140px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-17.png\"/>\n        <img class=\"abs halfScale 36-rolemodel\" style=\"top:684px;left:260px;\" src=\"/dakar2026/en/static/_content/36-rolemodel-18.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.staggerFromTo(cOf(\"36-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 0.8)\n          .staggerFromTo(cOf(\"36-rolemodel\"), 0.5, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.2);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Athlete Role Models  Contents  36  Meet your Athlete Role Models  Xiaoxiao Lai  Yannick Languina  Rayssa Leal  Vincent Luis  Jamila Lunkuse  People's Republic of China Wushu  Senegal | Tennis  Brazil | Skateboarding  France | Triathlon  Uganda | Swimming  Dina Meshref  Halimah Nakaayi  Kaylia Nemour  Blessing Oborududu  Hiroto Ono (HIRO10)  Egypt | Table Tennis  Uganda | Athletics  Algeria | Artistic Gymnastics  Nigeria | Wrestling  Japan | Breaking  Forrester Osei  Ayako Rokkaku  Elnaz Rekabi  Edmond Sanka  Combe Seck  Ghana | Weightlifting  Japan | Baseball/Softball  Iran | Climbing  Senegal | Canoe Sprint, Para Canoe  Senegal | Canoe Sprint  Richard Torrez Jr.  Maja Włoszczowska  Siwei Zheng  United States of America | Boxing  Poland | Cycling Mountain Bike  People's Republic of China Badminton  Athlete EDUCATION PROGRAMME"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 37-title\" style=\"top:326px;left:20px;\" src=\"/dakar2026/en/static/_content/37-title-1.png\"/>\n      <img class=\"abs halfScale 37-title\" style=\"top:439px;left:20px;\" src=\"/dakar2026/en/static/_content/37-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim.staggerFromTo(cOf(\"37-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Inside Sport Sessions  Inside Sport Sessions Come together with other athletes from your sport to learn sport-specific lessons and engage with your Athlete Role Models. At some point during Dakar 2026, you will have the chance to attend an Inside Sport Session dedicated to your discipline. Led by International Federations (IFs), these sessions provide an opportunity to: • Meet others who compete in the same sport as you • Learn more about your sport from elite athletes and IF staff •M  eet your Athlete Role Model(s) and ask them questions The date and time of your session will be communicated to you before the Games.  Athlete EDUCATION PROGRAMME  37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 38-title\" style=\"top:206px;left:218px;\" src=\"/dakar2026/en/static/_content/38-title-1.png\"/>\n      <img class=\"abs halfScale 38-title\" style=\"top:285px;left:216px;\" src=\"/dakar2026/en/static/_content/38-title-2.png\"/>\n      <img class=\"abs halfScale 38-title\" style=\"top:381px;left:219px;\" src=\"/dakar2026/en/static/_content/38-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(39);\" style=\"top:480px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(40);\" style=\"top:513px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(41);\" style=\"top:546px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(42);\" style=\"top:580px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(43);\" style=\"top:614px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(44);\" style=\"top:648px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(45);\" style=\"top:680px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(46);\" style=\"top:714px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(47);\" style=\"top:746px; left:216px; width:218px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(48);\" style=\"top:780px; left:216px; width:218px; height:22px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.staggerFromTo(cOf(\"38-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Need to know  NEED TO KNOW Essential information for a stress-free Games. 39  How to seek help  40 Online abuse protection 41  Mindfulness app  42  Anti-doping  43  Athlete expression  44  Content guidelines  45  How to access tickets  46  Get Set – Train Smarter  47  Sustainability  48  Departures  38"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 39-title\" style=\"top:97px;left:22px;\" src=\"/dakar2026/en/static/_content/39-title-1.png\"/>\n      <img class=\"abs halfScale 39-title\" style=\"top:150px;left:21px;\" src=\"/dakar2026/en/static/_content/39-title-2.png\"/>\n      <img class=\"abs halfScale 39-title\" style=\"top:213px;left:21px;\" src=\"/dakar2026/en/static/_content/39-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 39-btn pointer\" style=\"top:225px;left:264px;\" src=\"/dakar2026/en/static/_content/39-button-1.png\"/>\n      <img class=\"abs halfScaleC halfpulse animatedpulse 39-btn pointer\" style=\"top:666px;left:357px;\" src=\"/dakar2026/en/static/_content/39-button-2.png\"/>\n\n      <a class=\"abs\" href=\"https://ioc.integrityline.org/\" style=\"top:686px;left:416px;width:120px;height:41px;border-radius:30px;\" target=\"_blank\"></a>\n      <a class=\"abs\" href=\"mailto:safeguardingofficer@olympic.org\" style=\"top:245px;left:371px;width:212px;height:42px;border-radius:30px;\" target=\"_blank\"></a>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.staggerFromTo(cOf(\"39-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | How to seek help  How to seek help Whether you find yourself struggling or have seen something that doesn't feel right, here's how to find support. No pressure, no judgement – just someone who’s got your back.  39  IOC Safeguarding Officers:  Whether you need support, have a question or simply want to talk to someone, head to the Mind, Body and Me space at Athlete365 House to speak to a trained IOC Safeguarding Officer. They are there for you throughout the Games. You can also reach out to them via email.  Email safeguardingofficer@olympic.org  Emergency services:  In case of an emergency, dial +221 followed by: POLICE: 17 FIRE SERVICE: 18 AMBULANCE: 1515  IOC Integrity Hotline: If you’re being subject to harassment/abuse, spot something that doesn’t feel right, or want to report suspected competition manipulation, file an online report. You can remain anonymous if you wish.  CONTACT THE IOC INTEGRITY HOTLINE  Need to know"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 40-title\" style=\"top:97px;left:22px;\" src=\"/dakar2026/en/static/_content/40-title-1.png\"/>\n      <img class=\"abs halfScale 40-title\" style=\"top:150px;left:21px;\" src=\"/dakar2026/en/static/_content/40-title-2.png\"/>\n      <img class=\"abs halfScale 40-title\" style=\"top:213px;left:21px;\" src=\"/dakar2026/en/static/_content/40-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Online abuse protection  Contents  40  Protecting you from abuse on social media A monitoring system powered by artificial intelligence (AI) is in place to help protect athletes from online abuse on social media during the Games.  How does the service work?  The system uses AI to identify abusive comments, images or emojis directed at athletes on public-facing accounts and flag them for swift action by the platform.  Across two Olympic Games, the service has:  Analysed 4.3 million posts and comments directed at more  than 26,000 athletes' and officials' social media handles in real time   Flagged ~242,000 posts and comments as potentially abusive ~24,700 posts and comments as abusive and reported  Verified these to the platforms  How effective is the service?   Detected ~18,900 unique accounts sending abusive messages  Who is covered? When is the service in place?  Need to know  All competing athletes are automatically covered. You can opt out at any time by sending an email to safeguardingofficer@olympic.org.  The service will start on 29 October 2026 and end on 15 November 2026."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 41-title\" style=\"top:97px;left:22px;\" src=\"/dakar2026/en/static/_content/41-title-1.png\"/>\n      <img class=\"abs halfScale 41-title\" style=\"top:150px;left:21px;\" src=\"/dakar2026/en/static/_content/41-title-2.png\"/>\n      <img class=\"abs halfScale 41-title\" style=\"top:213px;left:21px;\" src=\"/dakar2026/en/static/_content/41-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 41-btn pointer\" style=\"top:550px;left:-77px;\" src=\"/dakar2026/en/static/_content/41-button-1.png\"/>\n\n      <a class=\"abs\" href=\"https://www.olympics.com/athlete365/offers/mental-health/free-mindfulness-app-subscription\" style=\"top:564px;left:18px;width:195px;height:30px;border-radius:30px;\" target=\"_blank\"></a>\n\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.staggerFromTo(cOf(\"41-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Mindfulness app  Claim your free mindfulness app subscription Want to improve your mental fitness or learn new ways to deal with stressful situations? Get a free one-year subscription to a leading mindfulness app – on us. As an athlete, you know that physical fitness is essential to success, but what about your mental game? Are you training your mind just as hard as you train your body? Mindfulness is the powerful practice of paying attention to the present moment and is proven to help improve your mental health and performance. We’re offering all Athlete365 members a free one-year premium subscription to a leading mindfulness app, helping you stay on top of your game at Dakar 2026 and beyond.  claim your subscription  Need to know  41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 42-title\" style=\"top:97px;left:21px;\" src=\"/dakar2026/en/static/_content/42-title-1.png\"/>\n      <img class=\"abs halfScale 42-title\" style=\"top:150px;left:21px;\" src=\"/dakar2026/en/static/_content/42-title-2.png\"/>\n      <img class=\"abs halfScale 42-title\" style=\"top:213px;left:21px;\" src=\"/dakar2026/en/static/_content/42-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 42-btn pointer\" style=\"top:317px;left:-68px;\" src=\"/dakar2026/en/static/_content/42-button-1.png\"/>\n      <img class=\"abs halfScaleC halfpulse animatedpulse 42-btn pointer\" style=\"top:498px;left:267px;\" src=\"/dakar2026/en/static/_content/42-button-2.png\"/>\n      <img class=\"abs halfScaleC halfpulse animatedpulse 42-btn pointer\" style=\"top:336px;left:254px;\" src=\"/dakar2026/en/static/_content/42-button-2.png\"/>\n\n      <a class=\"abs\" href=\"https://stillmed.olympics.com/media/Documents/Olympic-Games/Youth-Olympic-Games/Dakar-2026/IOC-Anti-Doping-Rules-applicable-to-the-4th-Summer-Youth-Olympic-Games-Dakar-2026.pdf\" style=\"top:331px;left:19px;width:174px;height:33px;border-radius:30px;\" target=\"_blank\"></a>\n      <a class=\"abs\" href=\"https://ita.sport/an-athlete-guide-for-clean-sport-at-dakar-2026-2/\" style=\"top:351px;left:319px;width:134px;height:32px;border-radius:30px;\" target=\"_blank\"></a>\n      <a class=\"abs\" href=\"https://ita.sport/resource/a-guide-to-doping-control-for-athletes-who-are-minors-2/\" style=\"top:513px;left:332px;width:134px;height:32px;border-radius:30px;\" target=\"_blank\"></a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.staggerFromTo(cOf(\"42-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Anti-doping  42  Anti-doping rules and resources Every athlete and entourage member attending the Youth Olympic Games must comply with the IOC’s anti-doping rules. To protect yourself and your place at the Games, it is essential that you understand the anti-doping rules that are in place.  FULL ANTI-DOPING RULES  Before you arrive in Dakar, explore the Athlete Guide for Clean Sport at Dakar 2026 for practical advice, key anti-doping information and resources to help you compete clean and confidently.  READ THE GUIDE New to doping control? We've got you covered. Download and share this practical guide to learn what to expect during the doping control process, including the modifications in place for athletes under 18.  READ THE GUIDE  Need to know"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 43-title\" style=\"top:391px;left:21px;\" src=\"/dakar2026/en/static/_content/43-title-1.png\"/>\n      <img class=\"abs halfScale 43-title\" style=\"top:455px;left:21px;\" src=\"/dakar2026/en/static/_content/43-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 43-btn pointer\" style=\"top:751px;left:-58px;\" src=\"/dakar2026/en/static/_content/43-button-1.png\"/>\n\n      <a class=\"abs\" href=\"https://www.olympics.com/athlete365/articles/athlete-expression/athlete-expression-guidelines-for-dakar-2026\" style=\"top:766px;left:22px;width:160px;height:33px;border-radius:30px;\" target=\"_blank\"></a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.staggerFromTo(cOf(\"43-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete expression  Athlete Expression The Athlete Expression Guidelines outline the opportunities you have to express your views at the Games while respecting others. Built on the results of our consultation with more than 3,500 athletes, the Athlete Expression Guidelines aim to ensure that: • Sport at the Youth Olympic Games is neutral and separate from political, religious or any other type of interference • The focus on the field of play during competitions and official ceremonies is on celebrating athletes’ performances • The Youth Olympic Village provides respectful conditions for all athletes to live together  READ THE GUIDELINES  Need to know  43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 44-title\" style=\"top:99px;left:21px;\" src=\"/dakar2026/en/static/_content/44-title-1.png\"/>\n      <img class=\"abs halfScale 44-title\" style=\"top:150px;left:21px;\" src=\"/dakar2026/en/static/_content/44-title-2.png\"/>\n      <img class=\"abs halfScale 44-title\" style=\"top:212px;left:21px;\" src=\"/dakar2026/en/static/_content/44-sub-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax();\n          pg44Anim.staggerFromTo(cOf(\"44-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg44Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Dakar 2026 | Content guidelines  Content guidelines You are encouraged to share your Youth Olympic Games experience with your family, friends and supporters. The IOC content guidelines set out exactly where and when you are able to capture content and what you can share on your social media accounts or other channels. You will need to follow the guidelines from 27 October to 15 November 2026.  Need to know  Why do these guidelines exist? The guidelines allow you to share your experience at the Games while protecting the rights of IOC Media Rights-Holders. Guidelines apply to both athletes and other accredited individuals, and will be available soon on Athlete365.  44"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 45-title\" style=\"top:99px;left:21px;\" src=\"/dakar2026/en/static/_content/45-title-1.png\"/>\n      <img class=\"abs halfScale 45-title\" style=\"top:161px;left:21px;\" src=\"/dakar2026/en/static/_content/45-sub-1.png\"/>\n\n      <img class=\"abs halfScale 45-bottom-bar\" style=\"top:835px;left:0px;\" src=\"/dakar2026/en/static/_content/45-bottom-bar-1.png\"/>\n\n      <div class=\"abs\" style=\"top:653px;left:54px;height: 182px;width: 133px;overflow:hidden;\">\n        <img class=\"abs halfScale 45-box\" style=\"top:43px;left:0px;\" src=\"/dakar2026/en/static/_content/45-box-1.png\"/>\n        <img class=\"abs halfScaleC 45-button\" id=\"button\" style=\"top:121px;left:-38px;\" src=\"/dakar2026/en/static/_content/45-button-1.png\"/>\n        <a href=\"https://tickets.dakar2026.org/en\" target=\"_blank\">\n          <div class=\"abs pointer\" style=\"top:139px;left:10px;width:114px;height:29px;border-radius:30px;\"></div>\n        </a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim.staggerFromTo(cOf(\"45-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"45-box\"), 0.6, {opacity:0, y: 100}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"45-button\"), 0.8, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1.6);\n          setTimeout(function(){\n            addPulse(\"button\")\n          }, 3000)\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg45Anim.stop();\n          removePulse(\"button\")\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | How to access tickets  Contents  45  How to access tickets Want to secure tickets for yourself and your loved ones? Here are your ticketing options. Tickets for family and friends  Opportunities for athletes  The Athletes’ Friends and Family Ticketing Programme guarantees you the chance to buy two tickets per session in which you are competing. This ensures that your loved ones can be there to support you if they are in Dakar.  Under the Same Discipline and Different Discipline Athletes programmes, you are able to attend any sporting session during the Games for free, using your accreditation.  Want to buy extra tickets?  Register now to access general ticket sales.  GET TICKETS Need to know  Note that you must be accompanied by a team official and access is on a first-come, first-served basis. Speak to your NOC for more information."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 46-title\" style=\"top:202px;left:20px;\" src=\"/dakar2026/en/static/_content/46-title-1.png\"/>\n      <img class=\"abs halfScale 46-title\" style=\"top:266px;left:20px;\" src=\"/dakar2026/en/static/_content/46-sub-1.png\"/>\n\n      <div class=\"addContentLink\" style=\"top:81px;left:20px;width:42px;height:42px;\">\n        <a href=\"https://play.google.com/store/apps/details?id=org.olympic.app.getset&hl=en_GB\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:81px;left:176px;width:42px;height:42px;\">\n        <a href=\"https://apps.apple.com/gb/app/get-set-train-smarter/id894609112\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax();\n          pg46Anim.staggerFromTo(cOf(\"46-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg46Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Get Set – Train Smarter  Contents  Google Play Store  App Store  Get Set – Train Smarter The Get Set – Train Smarter app helps incorporate injury prevention into your exercise routines using scientifically proven methods – allowing you to perform at your best and stay injury free when you need it the most. Prevent injuries with effective and evidence-based workout routines Exercises included for 55 sports Target the area you want to work on  Get Set is available in 11 languages: English, French, Spanish, Russian, German, Norwegian, Chinese, Korean, Finnish, Italian and Slovenian.  Need to know  46"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 47-title\" style=\"top:99px;left:20px;\" src=\"/dakar2026/en/static/_content/47-title-1.png\"/>\n      <img class=\"abs halfScale 47-title\" style=\"top:161px;left:20px;\" src=\"/dakar2026/en/static/_content/47-sub-1.png\"/>\n\n      <img class=\"abs halfScale 47-box\" style=\"top:220px;left:20px;\" src=\"/dakar2026/en/static/_content/47-box-1.png\"/>\n      <img class=\"abs halfScale 47-subtext\" style=\"top:249px;left:42px;\" src=\"/dakar2026/en/static/_content/47-subtext-1.png\"/>\n      <img class=\"abs halfScaleC 47-icon\" style=\"top:294px;left:7px;\" src=\"/dakar2026/en/static/_content/47-icon-1.png\"/>\n      <img class=\"abs halfScale 47-text\" style=\"top:326px;left:96px;\" src=\"/dakar2026/en/static/_content/47-text-1.png\"/>\n      <img class=\"abs halfScaleC 47-icon\" style=\"top:374px;left:7px;\" src=\"/dakar2026/en/static/_content/47-icon-2.png\"/>\n      <img class=\"abs halfScale 47-text\" style=\"top:416px;left:96px;\" src=\"/dakar2026/en/static/_content/47-text-2.png\"/>\n      <img class=\"abs halfScaleC 47-icon\" style=\"top:457px;left:7px;\" src=\"/dakar2026/en/static/_content/47-icon-3.png\"/>\n      <img class=\"abs halfScale 47-text\" style=\"top:488px;left:96px;\" src=\"/dakar2026/en/static/_content/47-text-3.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 47-btn pointer\" style=\"top:502px;left:406px;\" src=\"/dakar2026/en/static/_content/47-button-1.png\"/>\n      <a class=\"abs\" href=\"https://stillmed.olympics.com/media/Documents/Beyond-the-Games/Sustainability/Essentials/How-to-be-a-sustainable-champion-guide.pdf\" style=\"top:517px;left:465px;width:124px;height:32px;border-radius:30px;\" target=\"_blank\"></a>\n\n      <img class=\"abs halfScale 47-subtext-2\" style=\"top:594px;left:161px;\" src=\"/dakar2026/en/static/_content/47-subtext-2.png\"/>\n      <img class=\"abs halfScaleC 47-icon-2\" style=\"top:608px;left:-5px;\" src=\"/dakar2026/en/static/_content/47-icon-4.png\"/>\n      <img class=\"abs halfScale 47-text-2\" style=\"top:726px;left:28px;\" src=\"/dakar2026/en/static/_content/47-text-4.png\"/>\n      <img class=\"abs halfScaleC 47-icon-2\" style=\"top:608px;left:117px;\" src=\"/dakar2026/en/static/_content/47-icon-5.png\"/>\n      <img class=\"abs halfScale 47-text-2\" style=\"top:726px;left:133px;\" src=\"/dakar2026/en/static/_content/47-text-5.png\"/>\n      <img class=\"abs halfScaleC 47-icon-2\" style=\"top:608px;left:239px;\" src=\"/dakar2026/en/static/_content/47-icon-6.png\"/>\n      <img class=\"abs halfScale 47-text-2\" style=\"top:726px;left:254px;\" src=\"/dakar2026/en/static/_content/47-text-6.png\"/>\n      <img class=\"abs halfScaleC 47-icon-2\" style=\"top:608px;left:361px;\" src=\"/dakar2026/en/static/_content/47-icon-7.png\"/>\n      <img class=\"abs halfScale 47-text-2\" style=\"top:726px;left:392px;\" src=\"/dakar2026/en/static/_content/47-text-7.png\"/>\n      <img class=\"abs halfScaleC 47-icon-2\" style=\"top:608px;left:483px;\" src=\"/dakar2026/en/static/_content/47-icon-8.png\"/>\n      <img class=\"abs halfScale 47-text-2\" style=\"top:726px;left:503px;\" src=\"/dakar2026/en/static/_content/47-text-8.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.staggerFromTo(cOf(\"47-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"47-box\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"47-subtext\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .staggerFromTo(cOf(\"47-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.8)\n          .staggerFromTo(cOf(\"47-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.9)\n\n          .fromTo(cOf(\"47-subtext-2\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n          .staggerFromTo(cOf(\"47-icon-2\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.4)\n          .staggerFromTo(cOf(\"47-text-2\"), 0.8, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 2.6);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg47Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Sustainability  Contents  47  Sustainability at the Games As athletes, you have a key role to play in ensuring Dakar 2026 leaves a positive legacy for the local community and environment.  Sustainability objectives: Reduce waste and promote circular economy  Protect the natural environment Learn how you can be a sustainable champion with our guide.  Use environmentally and socially conscious products and services  FIND OUT MORE  How can athletes contribute?  Drink with less impact: Use a reusable water bottle  Need to know  Two bins, Eat local, zero excuses: feel global: Follow waste-sorting Opt for low carbon instructions to and more sustainable maximise recycling food options  Feed yourself, not the bin: Cut food waste by taking only what you need  Don’t need, don’t take: Refuse any unnecessary goods"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <img class=\"abs halfScale 48-title\" style=\"top:97px;left:21px;\" src=\"/dakar2026/en/static/_content/48-title-1.png\"/>\n      <img class=\"abs halfScale 48-title\" style=\"top:160px;left:21px;\" src=\"/dakar2026/en/static/_content/48-sub-1.png\"/>\n      \n      <img class=\"abs halfScaleC 48-icon\" style=\"top:293px;left:-4px;\" src=\"/dakar2026/en/static/_content/48-icon-1.png\"/>\n      <img class=\"abs halfScaleC 48-icon\" style=\"top:388px;left:-4px;\" src=\"/dakar2026/en/static/_content/48-icon-2.png\"/>\n      <img class=\"abs halfScaleC 48-icon\" style=\"top:484px;left:-4px;\" src=\"/dakar2026/en/static/_content/48-icon-3.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"48-icon\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "Get Ready Pack: Dakar 2026 | Departures  Contents  Departures What to expect when heading home after the Games.  On the day of your departure, your NOC will take you to the transport zone, where you will board a bus for the airport.  At the airport, you will be guided through check-in, security and immigration.  Finally, you will board your flight and head home from Dakar 2026.  From all of us at Athlete365, we hope you have a smooth journey and return home with special memories from your Youth Olympic Games experience!  Need to know  48"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:12px; left:20px; width:48px; height:10px;\"></div>\n      \n      <div class=\"addContentLink\" style=\"top:753px;left:500px;width:32px;height:30px\">\n        <a href=\"https://www.facebook.com/Athlete365/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:753px;left:538px;width:32px;height:30px\">\n        <a href=\"https://www.linkedin.com/showcase/athlete365/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:792px;left:500px;width:32px;height:30px\">\n        <a href=\"https://x.com/Athlete365\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:792px;left:538px;width:32px;height:30px\">\n        <a href=\"https://www.instagram.com/athlete365/\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:833px;left:469px;width:134px;height:19px\">\n        <a href=\"https://www.olympics.com/athlete365\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "FOLLOW US olympics.com/athlete365"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'addContentLinkThree'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function addPulse(id) {\n        var element = document.getElementById(id)\n        element.classList.add(\"halfpulse\")\n        element.classList.add(\"animatedpulse\")\n      }\n      \n      function removePulse(id) {\n        var element = document.getElementById(id)\n        element.classList.remove(\"halfpulse\")\n        element.classList.remove(\"animatedpulse\")\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay = 1, stagger = 0.3) {\n        numbers = cOf(klass)\n\n        setTimeout(function() {\n          for (let i = 0; i < numbers.length; i++) {\n            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])\n          }\n        }, delay * 1000)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-QXWN82KWPE" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SsTx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZuIu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cSdr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dUvF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ij1X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0c0c582d050e794a92fc.js